webpackJsonp([9],{

/***/ "/Nms":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__ = __webpack_require__("h9wt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_527b2a02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__ = __webpack_require__("cILH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_527b2a02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/TaY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: { showMenu: { type: Boolean } },
  data: function data() {
    return {
      title: 'Display Case Manager',
      menuItems: ['Metro Blue Line', 'Metro Red Line', 'Metro Green Line', 'Metro Gold Line', 'Metro Purple Line', 'Metro Red Line'],
      drawer: null,
      items: [{ title: 'Logout', icon: 'exit_to_app', href: '/logout', color: 'black' }],
      show: false,
      right: null,
      menu: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({ currentUser: 'currentUser' }), {
    menuItems1: function menuItems1() {
      var items = [{ title: 'Home', icon: 'home', href: '/', color: 'black' }, { title: 'Search', icon: 'search', href: '/search', color: 'black' }, { title: 'Export', icon: 'fas fa-file', href: '/report', color: 'black' }, { title: 'History', icon: 'history', href: '/history', color: 'black' }, { title: 'Create Tasks', icon: 'fas fa-list-ol', href: '/installation', color: 'black' }, { title: 'Tasks', icon: 'fas fa-tasks', href: '/tasks', color: 'black' }, { title: 'Installer Tasks', icon: 'fas fa-list-ol', href: '/installertasks', color: 'black' }];
      return items;
    },
    menuItems2: function menuItems2() {
      var items = [{
        action: 'directions_railway',
        title: 'Metro Locations',
        items: [{ title: 'Metro Blue Line', icon: 'directions_railway', href: '/rail/801', color: 'indigo' }, { title: 'Metro Red Line', icon: 'directions_railway', href: '/rail/802', color: 'red' }, { title: 'Metro Green Line', icon: 'directions_railway', href: '/rail/803', color: 'green' }, { title: 'Metro Gold Line', icon: 'directions_railway', href: '/rail/804', color: 'amber' }, { title: 'Metro Purple Line', icon: 'directions_railway', href: '/rail/805', color: 'purple' }, { title: 'Metro Expo Line', icon: 'directions_railway', href: '/rail/806', color: 'light-blue' }, { title: 'Metro Orange Line', icon: 'directions_bus', href: '/rail/901', color: 'orange' }, { title: 'Metro Silver Line 910', icon: 'directions_bus', href: '/rail/910', color: 'grey' }, { title: 'Metro Silver Line 950', icon: 'directions_bus', href: '/rail/950', color: 'grey' }]
      }, {
        action: 'directions_railway',
        title: 'Offsite Locations',
        items: [{
          title: 'Coming Soon..', icon: '', href: '', color: 'black'
        }]
      }, {
        action: 'settings',
        title: 'Settings',
        items: [{
          title: 'Enable Display Cases', icon: '', href: '/enablecases', color: 'black'
        }]
      }];
      return items;
    }
  }),
  methods: {
    something: function something() {
      this.show = true;
    },
    home: function home() {
      this.$router.push('/');
    }
  }
});

/***/ }),

/***/ "/ruN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__("npIG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5cc4e38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__("qGEl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5cc4e38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "04Xd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      password: '',
      openDialog: false,
      errorMsg: 'Please check your e-mail or password',
      show2: false,
      rules: {
        required: function required(value) {
          return !!value || 'Required.';
        }
      }
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({ currentUser: 'currentUser', er: 'menuStatus' })),
  created: function created() {
    this.checkLogin();
  },
  updated: function updated() {
    this.checkLogin();
  },

  methods: {
    checkLogin: function checkLogin() {
      if (this.currentUser) {
        this.$router.replace(this.$route.query.redirect || '/home');
      }
    },
    login: function login() {
      var _this = this;

      this.$http.post('/auth/login', {
        email: this.email.trim(),
        password: this.password
      }).then(function (request) {
        return _this.loginSuccessful(request);
      }).catch(function () {
        return _this.loginFailed();
      });
    },
    loginSuccessful: function loginSuccessful(req) {
      if (!req.data.token) {
        this.loginFailed();
        return;
      }
      localStorage.token = req.data.token;
      this.$store.dispatch('login');
      this.error = false;
      this.$router.replace(this.$route.query.redirect || '/home');
    },
    loginFailed: function loginFailed() {
      this.error = 'Login failed!';
      this.openDialog = true;
      this.$store.dispatch('logout');
      delete localStorage.token;
    },
    signup: function signup() {
      this.$router.push('/signup');
    },
    reset: function reset() {
      this.$router.push('/resetpassword');
    }
  },
  props: {
    source: String
  }
});

/***/ }),

/***/ "3EV+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__("Zx1r");





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */]);

/***/ }),

/***/ "4hRS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backend_vue_axios_axios_js__ = __webpack_require__("Zx1r");

var state = {
  displays: null,
  tasks: null
};
var mutations = {
  setDisplays: function setDisplays(state, payload) {
    state.displays = payload;
  },
  resetState: function resetState(state) {
    state.displays = null;
  }
};
var getters = {
  getDisplay: function getDisplay(state) {
    return state.displays;
  }
};
var actions = {
  callApi: function callApi(_ref, payload) {
    var commit = _ref.commit;

    commit('resetState');
    __WEBPACK_IMPORTED_MODULE_0__backend_vue_axios_axios_js__["a" /* default */].get(payload.url).then(function (response) {
      var code = [];
      if (response.data !== null) {
        response.data.forEach(function (item) {
          if (item !== null) {
            item.portalFeature.forEach(function (pf) {
              pf.featureDisplay.forEach(function (fd) {
                var obj = {
                  id: fd.id,
                  code: fd.code,
                  station: fd.portal_name,
                  displayId: fd.displayId
                };
                code.push(obj);
              });
            });
          }
        });
      }
      commit('setDisplays', code);
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
});

/***/ }),

/***/ "6Y4p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DisplayGrid_vue__ = __webpack_require__("pILX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b38c1782_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DisplayGrid_vue__ = __webpack_require__("KR0X");
function injectStyle (ssrContext) {
  __webpack_require__("UgKV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DisplayGrid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b38c1782_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DisplayGrid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7tmk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DisplaySelector_vue__ = __webpack_require__("wi2W");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4f16866_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DisplaySelector_vue__ = __webpack_require__("z+f4");
function injectStyle (ssrContext) {
  __webpack_require__("mAUx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b4f16866"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DisplaySelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4f16866_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DisplaySelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8AAR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    addInfo: {
      type: Object
    },
    cr: {
      type: Object
    },
    openAddForm: {
      type: Boolean
    },
    readonly: {
      type: Boolean
    },
    railId: {
      type: String
    },
    editDisplayFromSearch: {
      type: Object
    },
    data: {
      type: Object
    },
    item_code: {
      type: String
    },
    id: {
      type: String
    },
    search: {
      type: Boolean
    },
    displayEdit: {
      type: Object
    }
  },
  data: function data() {
    return {
      alertInput: false,
      menuDateCreated: false,
      menuDateUpdated: false,
      dateOpen: null,
      dateUpdated: null,
      portal_name: '',
      title: 'Add Display',
      icon: 'add_circle',
      loc_descrp: '',
      dplay_id: '',
      code: '',
      station_code: '',
      station_loc: '',
      size: '',
      shared: '',
      type: '',
      latitude: null,
      longitude: null,
      mTicket: '',
      status: '',
      comments: '',
      picture: '',
      image: null,
      imageUrl: '',
      displayType: ['Backlit', 'Non-backlit', 'Bus Shelter'],
      displayStatus: ['Active', 'Empty', 'Needs Repair'],
      sharedDisplay: ['Yes', 'No'],
      typeHint: 'Type of display example Backlit, Non-backlit, or Bus Shelter',
      statusHint: 'Status of the display',
      sharedHint: 'select if display shared between multiple lines',
      openForms: {
        add_Display: false,
        edit_Display: false,
        search: false,
        searchDisplayEdit: false
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({ currentUser: 'currentUser' })),
  watch: {
    displayEdit: function displayEdit(d) {
      this.title = 'Edit Display';
      this.icon = 'edit';
      this.portal_name = d.portal_name;
      this.loc_descrp = d.loc_descrp;
      this.code = d.code;
      this.size = d.size;
      this.latitude = d.latitude;
      this.longitude = d.longitude;
      this.typeHint = 'Select the current value of "' + d.displayType + '" unless you want to change it';
      this.type = d.displayType;
      this.statusHint = 'Select the current value of "' + d.status + '" unless you want to change it';
      this.status = d.status;
      this.shared = d.isShared;
      this.sharedHint = 'Select the current value of "' + d.isShared + '" unless you want to change it';
      this.openForms.edit_Display = true;
      this.openForms.add_Display = false;
      this.openForms.search = false;
      this.openForms.searchDisplayEdit = false;
      this.dplay_id = d.id;
    },
    editDisplayFromSearch: function editDisplayFromSearch(d) {
      this.title = 'Edit Display';
      this.icon = 'edit';
      this.portal_name = d.portal_name;
      this.loc_descrp = d.loc_descrp;
      this.code = d.code;
      this.size = d.size;
      this.latitude = d.latitude;
      this.longitude = d.longitude;
      this.typeHint = 'Select the current value of "' + d.displayType + '" unless you want to change it';
      this.type = d.displayType;
      this.statusHint = 'Select the current value of "' + d.status + '" unless you want to change it';
      this.status = d.status;
      this.shared = d.isShared;
      this.sharedHint = 'Select the current value of "' + d.isShared + '" unless you want to change it';
      this.openForms.edit_Display = false;
      this.openForms.add_Display = false;
      this.openForms.search = false;
      this.openForms.searchDisplayEdit = true;
      this.dplay_id = d.id;
    },
    openAddForm: function openAddForm() {
      // adding a new display
      this.openForms.add_Display = true;
      this.openForms.edit_Display = false;
      this.openForms.search = false;
      this.openForms.searchDisplayEdit = false;
      this.title = 'Add Display';
      this.icon = 'add_circle';
      this.portal_name = this.addInfo.name;
    }
  },
  methods: {
    validate: function validate() {
      var vm = this;
      vm.$validator.validateAll().then(function (results) {
        if (results) {
          vm.save();
        } else {
          vm.alertInput = true;
        }
      });
    },
    save: function save() {
      var vm = this;
      if (vm.openForms.edit_Display) {
        // edit display
        var obj = {
          portal_name: vm.portal_name,
          loc_descrp: vm.loc_descrp,
          code: vm.code,
          displayType: vm.type,
          size: vm.size,
          latitude: vm.latitude,
          longitude: vm.longitude,
          isShared: vm.shared,
          status: vm.status,
          featureFk: vm.displayEdit.featureFk,
          displayId: vm.displayEdit.displayId,
          userFk: vm.currentUser.id,
          d_id: vm.dplay_id,
          rline: vm.cr.name
        };
        console.log(obj);
        var url = '/mapsdata/display/editdisplay';
        vm.$http.post(url, obj).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit('closeFormDisplayEdit', false);
          __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit('saveForm', true);
        });
      }
      if (vm.openForms.searchDisplayEdit) {
        // edit display from search
        var _obj = {
          portal_name: vm.portal_name,
          loc_descrp: vm.loc_descrp,
          code: vm.code,
          displayType: vm.type,
          size: vm.size,
          latitude: vm.latitude,
          longitude: vm.longitude,
          isShared: vm.shared,
          status: vm.status,
          featureFk: vm.editDisplayFromSearch.featureFk,
          displayId: vm.editDisplayFromSearch.displayId,
          userFk: vm.currentUser.id,
          d_id: vm.dplay_id,
          rline: vm.cr.name
        };
        var uri = '/mapsdata/display/editdisplay';
        vm.$http.post(uri, _obj).then(function (response) {
          var it = {
            msg: 'Successfully edit'
          };
          vm.$store.dispatch('closeForm');
          __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit('saveSearchEdit', it);
        });
      }
      if (vm.openForms.add_Display) {
        // adding new display
        var _vm = this;
        var _url = '/mapsdata/display/createdisplay';
        if (_vm.addInfo.portalFeature.length !== 0) {
          var addObj = {
            portal_name: _vm.portal_name,
            loc_descrp: _vm.loc_descrp,
            code: _vm.code,
            displayType: _vm.type,
            size: _vm.size,
            latitude: _vm.latitude,
            longitude: _vm.longitude,
            isShared: _vm.shared,
            status: _vm.status,
            featureFk: _vm.addInfo.portalFeature[0].id,
            displayId: _vm.addInfo.portalFeature[0].featureDisplay[0].displayId,
            stop_id: _vm.addInfo.stopId,
            railId: _vm.railId,
            userFk: _vm.currentUser.id,
            d_id: _vm.dplay_id,
            rline: _vm.cr.name
          };
          _vm.$http.post(_url, addObj).then(function (response) {
            _vm.$refs.form.reset();
            __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit('closeFormDisplayAdd', false);
            __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit('saveForm', true);
          });
        } else {
          var addObj_ = {
            portal_name: _vm.portal_name,
            loc_descrp: _vm.loc_descrp,
            code: _vm.code,
            displayType: _vm.type,
            size: _vm.size,
            latitude: _vm.latitude,
            longitude: _vm.longitude,
            isShared: _vm.shared,
            status: _vm.status,
            featureFk: '',
            stop_id: _vm.addInfo.stopId,
            displayId: '',
            railId: _vm.railId,
            userFk: _vm.currentUser.id,
            d_id: _vm.dplay_id,
            rline: _vm.cr.name
          };
          _vm.$http.post(_url, addObj_).then(function (response) {
            _vm.$refs.form.reset();
            __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit('closeFormDisplayAdd', false);
            __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit('saveForm', true);
          });
        }
      }
    },
    cancel: function cancel() {
      if (this.openForms.edit_Display) {
        this.$validator.reset();
        __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit('closeFormDisplayEdit', false);
      }
      if (this.openForms.add_Display) {
        // close add display
        this.$validator.reset();
        this.imageUrl = '';
        this.$refs.form.reset();
        __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit('closeFormDisplayAdd', false);
      }
      if (this.openForms.search) {
        // close form from search
        this.$validator.reset();
        this.$refs.form.reset();
        this.$store.dispatch('closeForm');
      }
      if (this.openForms.searchDisplayEdit) {
        // close edit form from search
        this.$validator.reset();
        this.$store.dispatch('closeForm');
      }
    },
    uploadFile: function uploadFile() {
      this.$refs.fileInput.click();
    },
    filePicked: function filePicked(event) {
      var _this = this;

      var files = event.target.files;
      var fname = files[0].name;
      if (fname.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file');
      }
      var fileReader = new FileReader();
      fileReader.addEventListener('load', function () {
        _this.imageUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
    },
    resetOpenForms: function resetOpenForms() {
      this.alertInput = false;
      this.openForms.edit_Display = false;
      this.openForms.add_Display = false;
      this.openForms.search = false;
    }
  }
});

/***/ }),

/***/ "8N3P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('v-container',{staticClass:"custom",attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',[(_vm.currentUser)?[_c('headerbar',{attrs:{"app":"","showMenu":_vm.show}})]:_vm._e()],2)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',[_c('main',[_c('router-view')],1)])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGOUT; });
/* unused harmony export SHOWMENU */
var LOGIN = 'LOGIN';
var LOGOUT = 'LOGOUT';
var SHOWMENU = 'SHOWMENU';

/***/ }),

/***/ "Dxk3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Display_vue__ = __webpack_require__("byRY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ad24be2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Display_vue__ = __webpack_require__("b1T4");
function injectStyle (ssrContext) {
  __webpack_require__("vvGB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ad24be2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Display_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ad24be2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Display_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EFA9":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "FJN/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Welcome_vue__ = __webpack_require__("XbJz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd788856_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Welcome_vue__ = __webpack_require__("aGBW");
function injectStyle (ssrContext) {
  __webpack_require__("g67T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fd788856"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Welcome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd788856_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Welcome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G2X2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth__ = __webpack_require__("jwGj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logs__ = __webpack_require__("jnyb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__search__ = __webpack_require__("laec");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resetPassword__ = __webpack_require__("l0b2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__showDisplay__ = __webpack_require__("RQuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__instructions__ = __webpack_require__("4hRS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tasks__ = __webpack_require__("dfk4");










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    auth: __WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */],
    logs: __WEBPACK_IMPORTED_MODULE_3__logs__["a" /* default */],
    search: __WEBPACK_IMPORTED_MODULE_4__search__["a" /* default */],
    instructions: __WEBPACK_IMPORTED_MODULE_7__instructions__["a" /* default */],
    resetPassword: __WEBPACK_IMPORTED_MODULE_5__resetPassword__["a" /* default */],
    showDisplay: __WEBPACK_IMPORTED_MODULE_6__showDisplay__["a" /* default */],
    tasks: __WEBPACK_IMPORTED_MODULE_8__tasks__["a" /* default */]
  }
}));

/***/ }),

/***/ "KR0X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-0 pa-0",attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm5":"","md3":""}},[(_vm.showDisplayCaseSelector)?[(_vm.$vuetify.breakpoint.smAndDown)?_c('div',[_c('h3',{staticClass:"pt-3 title",staticStyle:{"width":"250px"}},[_vm._v(_vm._s(_vm.dat[0].portal_name))])]):_c('div',[_c('h1',{staticClass:"pt-3 title"},[_vm._v(_vm._s(_vm.dat[0].portal_name))])]),_vm._v(" "),_c('v-select',{staticStyle:{"min-width":"175px"},attrs:{"items":_vm.dat,"item-text":"code","item-value":"code","label":"Select a Display Case","color":_vm.cr.colorName,"return-object":""},on:{"change":_vm.displayResults},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})]:_vm._e()],2)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[(_vm.showDisplay)?[_c('displayItem',{attrs:{"transition":"slide-y-transition","dat":_vm.displayCaseItem,"mapsData":_vm.maps,"railId":_vm.railId,"cr":_vm.cr,"addSwitch":_vm.s,"issues":_vm.listIssues}})]:_vm._e()],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28597bd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("8N3P");
function injectStyle (ssrContext) {
  __webpack_require__("sk2h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28597bd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MXwS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-0"},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-card',{staticClass:"elevation-12"},[_c('v-toolbar',{attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Login - Display Case Manager")])],1),_vm._v(" "),_c('v-card-text',[_c('v-form',[_c('v-text-field',{attrs:{"prepend-icon":"person","name":"login","label":"E-mail","type":"text"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"id":"password","prepend-icon":"lock","name":"password","label":"Password","type":_vm.show2 ? 'text' : 'password',"append-icon":_vm.show2 ? 'visibility_off': 'visibility',"rules":[_vm.rules.required]},on:{"click:append":function($event){_vm.show2 = !_vm.show2},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('a',{on:{"click":function($event){$event.preventDefault();return _vm.reset($event)}}},[_vm._v("Forgot Password")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},nativeOn:{"click":function($event){return _vm.login($event)}}},[_vm._v("Login")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},nativeOn:{"click":function($event){return _vm.signup($event)}}},[_vm._v("Sign Up")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.openDialog),callback:function ($$v) {_vm.openDialog=$$v},expression:"openDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"error white--text"},[_c('v-icon',{staticClass:"white--text pr-3"},[_vm._v("warning")]),_c('span',[_vm._v("Login Error")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v(_vm._s(_vm.errorMsg))])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.openDialog=false}}},[_vm._v("Close")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bus", function() { return bus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__backend_vue_axios__ = __webpack_require__("3EV+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__("IcnI");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "7zck"));

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
/* eslint-disable no-new */
var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  axios: __WEBPACK_IMPORTED_MODULE_5__backend_vue_axios__["default"],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  VeeValidate: __WEBPACK_IMPORTED_MODULE_4_vee_validate__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "Obwe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qk/z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__displays_DisplaySelector__ = __webpack_require__("7tmk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__displays_DisplayGrid__ = __webpack_require__("6Y4p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MainContent',
  components: {
    displaySelector: __WEBPACK_IMPORTED_MODULE_3__displays_DisplaySelector__["a" /* default */],
    displayGrid: __WEBPACK_IMPORTED_MODULE_4__displays_DisplayGrid__["a" /* default */]
  },
  data: function data() {
    return {
      railname: '',
      dataObj: '',
      sel: '',
      e: '',
      displayData: [],
      data: [],
      issuesDat: [],
      showFlag: false,
      showResults: false,
      showButton: false,
      showCaseSelector: false,
      displayResults: [],
      toogleGrid: false,
      toggleBtn: false,
      iconVal: this.getIcon(this.$route.params.id),
      showItem: false,
      show: '',
      test: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])({
    currentUser: 'currentUser'
  })),
  mounted: function mounted() {
    var vm = this;
    vm.dataObj = vm.findRailBusName(vm.$route.params.id);
    vm.railname = vm.dataObj.name;
    vm.toogleGrid = true;
    vm.$nextTick().then(function (obj) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([vm.getDisplay(), vm.getMaps(), vm.getIssues()]).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (display, maps, issues) {
        var temp = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(display.data, function (i) {
          return i.portalFeature.length !== 0;
        });
        vm.displayData = temp;
        vm.data = maps.data;
        vm.issuesDat = issues.data;
      }));
    });
  },
  updated: function updated() {
    this.checkToken();
  },

  watch: {
    displayData: function displayData() {
      var vm = this;
      vm.displayData.forEach(function (el) {
        if (el.id === vm.sel) {
          if (el.portalFeature.length !== 0) {
            el.portalFeature.forEach(function (pf) {
              vm.displayResults = pf.featureDisplay;
            });
          }
        }
      });
      this.sortDisplayResults();
    }
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var vm = this;
    vm.dataObj = vm.findRailBusName(to.params.id);
    vm.railname = vm.dataObj.name;
    vm.toogleGrid = false;
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([vm.getDisplay(), vm.getMaps(), vm.getIssues()]).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (display, maps, issues) {
      var temp = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(display.data, function (i) {
        return i.portalFeature.length !== 0;
      });
      vm.displayData = temp;
      vm.data = maps.data;
      vm.issuesDat = issues.data;
      vm.showResults = false;
      vm.displayResults = [];
      vm.showButton = false;
      vm.toggleBtn = false;
      vm.sel = '';
      vm.showCaseSelector = false;
    }));
    next();
  },
  created: function created() {
    if (!this.checkToken()) {
      var vm = this;
      vm.dataObj = this.findRailBusName(this.$route.params.id);
      vm.toogleGrid = true;
      __WEBPACK_IMPORTED_MODULE_5__main__["bus"].$on('saveForm', function (data) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([vm.getDisplay(), vm.getMaps(), vm.getIssues()]).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (display, maps, issues) {
          var temp = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(display.data, function (i) {
            return i.portalFeature.length !== 0;
          });
          vm.displayData = temp;
          vm.data = maps.data;
          vm.issuesDat = issues.data;
          vm.showMaps(vm.sel);
        }));
      });
    }
  },

  methods: {
    showMaps: function showMaps(selected) {
      this.sel = selected;
      var vm = this;
      vm.showFlag = true;
      vm.results = '';
      vm.displayData.forEach(function (el) {
        if (el.id === vm.sel) {
          if (el.portalFeature.length !== 0) {
            el.portalFeature.forEach(function (pf) {
              vm.displayResults = pf.featureDisplay;
            });
            vm.showButton = true;
            vm.showResults = false;
            vm.toogleGrid = true;
            vm.showCaseSelector = true;
          } else {
            vm.showResults = false;
            vm.displayResults = '';
            vm.showButton = false;
            vm.toogleGrid = false;
            vm.showCaseSelector = false;
          }
        }
      });
      this.sortDisplayResults();
    },
    sortDisplayResults: function sortDisplayResults() {
      this.displayResults.forEach(function (item) {
        var c = item.code.split('_')[2].length === 2 ? item.code.split('_')[2].substr(0, 1) : item.code.split('_')[2].substr(0, 2);
        item.caseNum = parseInt(c);
      });
      var arr = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(this.displayResults, ['caseNum'], ['asc']);
      var results = [];
      arr.forEach(function (i) {
        if (i.status !== 'Disable') {
          results.push(i);
        }
      });
      this.displayResults = results;
    },
    checkToken: function checkToken() {
      if (window.localStorage.length === 0) {
        this.$router.push('/');
      } else {
        var vm = new Date();
        var v = new Date(this.currentUser.exp * 1000);
        if (!(vm.getTime() < v.getTime())) {
          this.$store.dispatch('logout');
        } else {
          return false;
        }
      }
    },
    tgBtn: function tgBtn() {
      this.toggleBtn = true;
    },
    getDisplay: function getDisplay() {
      var vm = this;
      var urlA = '/mapsdata/portal/display/' + vm.dataObj.id;
      return vm.$http.get(urlA);
    },
    getMaps: function getMaps() {
      var vm = this;
      var urlB = '/mapsdata/display/maps/rail_id/' + vm.dataObj.id;
      return vm.$http.get(urlB);
    },
    getIssues: function getIssues() {
      var vm = this;
      var urlC = '/mapsdata/display/issues/rail_id/' + vm.dataObj.id;
      return vm.$http.get(urlC);
    },
    findRailBusName: function findRailBusName(params) {
      var obj = { id: '', name: '', color: '' };
      if (params === '801') {
        obj.id = params;
        obj.name = 'Metro Blue Line';
        obj.color = '#3F51B5'; // indigo
        obj.colorName = 'indigo';
        return obj;
      } else if (params === '802') {
        obj.id = params;
        obj.name = 'Metro Red Line';
        obj.color = '#F44336'; // red
        obj.colorName = 'red';
        return obj;
      } else if (params === '803') {
        obj.id = params;
        obj.name = 'Metro Green Line';
        obj.color = '#4CAF50'; // green
        obj.colorName = 'green';
        return obj;
      } else if (params === '804') {
        obj.id = params;
        obj.name = 'Metro Gold Line';
        obj.color = '#FBC02D'; // gold
        obj.colorName = 'yellow darken-2';
        return obj;
      } else if (params === '805') {
        obj.id = params;
        obj.name = 'Metro Purple Line';
        obj.color = '#673AB7'; // purple
        obj.colorName = 'deep-purple lighten-1';
        return obj;
      } else if (params === '806') {
        obj.id = params;
        obj.name = 'Metro Expo Line';
        obj.color = '#2196F3'; // expo
        obj.colorName = 'blue';
        return obj;
      } else if (params === '901') {
        obj.id = params;
        obj.name = 'Metro Orange Line';
        obj.color = '#FF9800'; // orange
        obj.colorName = 'orange';
        return obj;
      } else if (params === '910' || params === '950') {
        obj.id = params;
        obj.name = 'Metro Silver Line';
        obj.color = '#9E9E9E'; // red
        obj.colorName = 'grey';
        return obj;
      } else {
        return '';
      }
    },
    getIcon: function getIcon(params) {
      if (params === '801' || params === '802' || params === '803' || params === '804' || params === '805' || params === '806') {
        return 'directions_railway';
      } else {
        return 'directions_bus';
      }
    }
  }
});

/***/ }),

/***/ "RQuH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backend_vue_axios_axios_js__ = __webpack_require__("Zx1r");



var state = {
  showIt: false,
  qc_verify: false,
  map_status: '',
  railData: null
};
var mutations = {
  setShowDisplayState: function setShowDisplayState(state, payload) {
    state.showIt = payload;
  },
  setQCVerify: function setQCVerify(state, payload) {
    state.qc_verify = payload;
  },
  setRailData: function setRailData(state, payload) {
    state.railData = payload;
  },
  resetData: function resetData(state) {
    state.railData = null;
  }
};
var getters = {
  showDisplay: function showDisplay(state) {
    return state.showIt;
  },
  getRailData: function getRailData(state) {
    return state.railData;
  }
};
var actions = {
  toggleDisplay: function toggleDisplay(_ref, payload) {
    var commit = _ref.commit;

    commit('setShowDisplayState', payload);
  },
  getStation: function getStation(_ref2, payload) {
    var _this = this;

    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var url, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = 'mapsdata/display/rail_id/' + payload.railId;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2__backend_vue_axios_axios_js__["a" /* default */].get(url);

            case 3:
              data = _context.sent;

              commit('resetData');
              commit('setRailData', data.data);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  resetStationData: function resetStationData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('resetData');
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
});

/***/ }),

/***/ "SHV0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm10":"","md8":"","lg6":""}},[_c('v-card',[_c('v-alert',{attrs:{"value":_vm.alertInput,"type":"error"}},[_vm._v("\n            "+_vm._s(_vm.errorMessage)+"\n            ")]),_vm._v(" "),_c('v-toolbar',{attrs:{"card":"","color":_vm.cr.colorName,"prominent":""}},[_c('v-toolbar-title',{staticClass:"body-3 white--text"},[_vm._v(_vm._s(_vm.formTitle)+"\n                "),_c('v-icon',{staticClass:"pl-2",attrs:{"color":"white"}},[_vm._v("add_circle")])],1),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',[(_vm.bulk)?[_c('v-alert',{attrs:{"dismissible":"","type":"warning"},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_vm._v("\n                  You are about to edit multiple items. Please make sure you know the fields you going to modify\n                ")])]:_vm._e(),_vm._v(" "),_c('v-form',{ref:"form"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:50'),expression:"'required|max:50'"}],attrs:{"label":"Title","hint":"Title of the graphic","error-messages":_vm.errors.collect('title'),"data-vv-name":"title","required":"","persistent-hint":""},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:5|numeric'),expression:"'required|max:5|numeric'"}],attrs:{"label":"Case Number","hint":"Usually 1,2,3... etc ","data-vv-name":"caseNum","required":"","persistent-hint":"","error-messages":_vm.errors.collect('caseNum')},model:{value:(_vm.caseNum),callback:function ($$v) {_vm.caseNum=$$v},expression:"caseNum"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:7|regex:[0-9]+\-[0-9]+'),expression:"'required|max:7|regex:[0-9]+\\-[0-9]+'"}],attrs:{"label":"Job Number","hint":"Example 15-0963","error-messages":_vm.errors.collect('jobNum'),"data-vv-name":"jobNum","required":"","persistent-hint":""},model:{value:(_vm.jobNum),callback:function ($$v) {_vm.jobNum=$$v},expression:"jobNum"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-menu',{ref:"menu",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Last Update (REQUIRED)","prepend-icon":"event","hint":"Date map was updated (required**)","persistent-hint":""},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary"},on:{"click":function($event){return _vm.$refs.menu.save(_vm.date)}}},[_vm._v("OK")]),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary"},on:{"click":function($event){_vm.menu = false}}},[_vm._v("Cancel")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"mt-4":""}},[_c('v-textarea',{directives:[{name:"validate",rawName:"v-validate",value:('max:500'),expression:"'max:500'"}],attrs:{"label":"Notes","hint":"Notes: about active content","persistent-hint":"","outline":"","error-messages":_vm.errors.collect('notes'),"data-vv-name":"notes"},model:{value:(_vm.notes),callback:function ($$v) {_vm.notes=$$v},expression:"notes"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-menu',{ref:"menuDateCreated",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","return-value":_vm.postby,"offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px","required":""},on:{"update:returnValue":function($event){_vm.postby=$event},"update:return-value":function($event){_vm.postby=$event}},model:{value:(_vm.menuDateCreated),callback:function ($$v) {_vm.menuDateCreated=$$v},expression:"menuDateCreated"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Post By","prepend-icon":"event","hint":"Post content by this date. You can leave it blank if YOU ARE NOT ADDING NEW CONTENT","persistent-hint":""},slot:"activator",model:{value:(_vm.postby),callback:function ($$v) {_vm.postby=$$v},expression:"postby"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":"","required":""},model:{value:(_vm.postby),callback:function ($$v) {_vm.postby=$$v},expression:"postby"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary"},on:{"click":function($event){return _vm.$refs.menuDateCreated.save(_vm.postby)}}},[_vm._v("OK")]),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary"},on:{"click":function($event){_vm.menuDateCreated = false}}},[_vm._v("Cancel")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input-group--focused",attrs:{"items":_vm.status,"label":"Status","input":"selected","item-value":"text","hint":_vm.selectHint,"persistent-hint":"","error-messages":_vm.errors.collect('selected'),"required":"","data-vv-name":"selected"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('max:15|regex:[a-zA-Z]+'),expression:"'max:15|regex:[a-zA-Z]+'"}],attrs:{"label":"Case Direction","hint":"Example: Left, Right, Middle...etc","error-messages":_vm.errors.collect('direction'),"data-vv-name":"direction","persistent-hint":""},model:{value:(_vm.direction),callback:function ($$v) {_vm.direction=$$v},expression:"direction"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"mt-4":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"color":_vm.cr.colorName},on:{"click":function($event){return _vm.validate()}}},[_vm._v("Save "),_c('v-icon',{staticClass:"pl-1",attrs:{"color":"white"}},[_vm._v("check_circle")])],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":_vm.cr.colorName},on:{"click":_vm.cancel}},[_vm._v("Cancel"),_c('v-icon',{staticClass:"pl-1",attrs:{"color":"white"}},[_vm._v("cancel")])],1)],1)],1)],1)],2)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UgKV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XbJz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  props: {
    msgs: { type: String }
  },
  data: function data() {
    return {
      msg: 'Display Case Manager'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({ currentUser: 'currentUser' }), {
    binding: function binding() {
      var binding = {};
      if (this.$vuetify.breakpoint.smAndDown) binding.column = true;
      return binding;
    },

    menuItems1: function menuItems1() {
      var items = [{ title: 'Search', icon: 'search', href: '/search', color: 'black', description: 'Search all app content' }, { title: 'Export', icon: 'fas fa-file', href: '/report', color: 'black', description: 'Export app content by line' }, { title: 'History', icon: 'history', href: '/history', color: 'black', description: 'App log history' }, { title: 'Tasks', icon: 'fas fa-tasks', href: '/tasks', color: 'black', description: 'All Tasks Available' }, { title: 'Create Tasks', icon: 'fas fa-list-ol', href: '/installation', color: 'black', description: 'Create new Installation Orders' }, { title: 'Installer Tasks', icon: 'fas fa-list-ol', href: '/installertasks', color: 'black', description: 'Installers current tasks' }];
      return items;
    },
    menuItems2: function menuItems2() {
      var items = [{ title: 'Metro Blue Line', icon: 'directions_railway', href: '/rail/801', color: 'indigo' }, { title: 'Metro Red Line', icon: 'directions_railway', href: '/rail/802', color: 'red' }, { title: 'Metro Green Line', icon: 'directions_railway', href: '/rail/803', color: 'green' }, { title: 'Metro Gold Line', icon: 'directions_railway', href: '/rail/804', color: 'amber' }, { title: 'Metro Purple Line', icon: 'directions_railway', href: '/rail/805', color: 'purple' }, { title: 'Metro Expo Line', icon: 'directions_railway', href: '/rail/806', color: 'light-blue' }, { title: 'Metro Orange Line', icon: 'directions_bus', href: '/rail/901', color: 'orange' }, { title: 'Metro Silver Line 910', icon: 'directions_bus', href: '/rail/910', color: 'grey' }, { title: 'Metro Silver Line 950', icon: 'directions_bus', href: '/rail/950', color: 'grey' }];
      return items;
    }
  }),
  created: function created() {
    this.checkToken();
  },

  methods: {
    checkToken: function checkToken() {
      if (window.localStorage.length === 0) {
        this.$router.push('/');
      } else {
        var current = new Date();
        var tokenDate = new Date(this.currentUser.exp * 1000);
        if (!(current.getTime() < tokenDate.getTime())) {
          this.$store.dispatch('logout');
        } else {
          return false;
        }
      }
    }
  }
});

/***/ }),

/***/ "Y+xe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-navigation-drawer',{staticClass:"nav-menu",attrs:{"temporary":"","fixed":"","right":"","app":"","width":"265","disable-resize-watcher":true},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-toolbar',{attrs:{"flat":"","color":"blue lighten-1"}},[_c('v-list',[_c('v-list-tile',[_c('v-list-tile-title',{staticClass:"title white--text"},[_vm._v("\n                  Menu\n                ")])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"two-line":"","subheader":""}},[_c('v-list-tile',[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v("person")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.currentUser.email))]),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(_vm.currentUser.firstname +" "+_vm.currentUser.lastname))])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{staticClass:"pt-0",attrs:{"dense":""}},_vm._l((_vm.menuItems1),function(item){return _c('v-list-tile',{key:item.title,attrs:{"to":item.href}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":item.color}},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',{class:item.color+'--text'},[_vm._v("\n                 "+_vm._s(item.title)+"\n              ")])],1)}),1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{staticClass:"pt-0",attrs:{"dense":""}},_vm._l((_vm.menuItems2),function(item){return _c('v-list-group',{key:item.title,attrs:{"prepend-icon":item.action,"no-action":""},model:{value:(item.active),callback:function ($$v) {_vm.$set(item, "active", $$v)},expression:"item.active"}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)],1),_vm._v(" "),_vm._l((item.items),function(subItem){return _c('v-list-tile',{key:subItem.title,attrs:{"to":subItem.href,"prepend-icon":subItem.icon}},[_c('v-list-tile-content',[_c('v-list-tile-content',{class:subItem.color+'--text darken-1',staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(subItem.title))])],1)],1)})],2)}),1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{staticClass:"pt-0",attrs:{"dense":""}},[_c('v-list-tile',{attrs:{"to":_vm.items[0].href}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.items[0].color}},[_vm._v(_vm._s(_vm.items[0].icon))])],1),_vm._v(" "),_c('v-list-tile-content',{class:_vm.items[0].color+'--text'},[_vm._v("\n                 "+_vm._s(_vm.items[0].title)+"\n              ")])],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"elevation-1 toolbar--fixed theme--dark pb-0",attrs:{"inline":"","app":""}},[_c('v-toolbar-items',{staticClass:"pr-4"},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("EFA9")},on:{"click":function($event){return _vm.home()}}})]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-title',{staticClass:"headbar-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-toolbar-side-icon',{attrs:{"dark":""},on:{"click":function($event){_vm.show=!_vm.show}}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YEz/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__ = __webpack_require__("olAn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    captcha: __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__["a" /* default */]
  },
  $validates: true,
  name: 'Logout',
  data: function data() {
    return {
      user: {
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        captchaToken: ''
      },
      openCaptcha: false,
      siteKey: '6LckcoUUAAAAAADvzeIYlFgM7XyhZqaTPUx-upzK',
      grant: false,
      errorMsg: '',
      msg: '',
      openDialog: false,
      show2: false,
      rules: {
        required: function required(value) {
          return !!value || 'Required.';
        },
        min: function min(v) {
          return v.length >= 8 || 'Min 8 characters';
        }
      }
    };
  },
  methods: {
    cancel: function cancel() {
      this.$router.push('/');
    },
    signup: function signup() {
      var _this = this;

      if (this.user.captchaToken !== '') {
        this.$http.post('/auth/signup', this.user).then(function (request) {
          return _this.success(request);
        }).catch(function () {
          return _this.failedSignUp();
        });
      }
    },
    success: function success(req) {
      if (req.status === 201) {
        this.msg = 'User successfully created. Login with your new credentials.';
        this.grant = true;
      } else {
        this.errorMsg = 'Please check your information fields';
        this.openDialog = true;
      }
    },
    failedSignUp: function failedSignUp() {
      this.errorMsg = 'Sorry, something went wrong. Please try again.';
      this.openDialog = true;
    },
    toLogin: function toLogin(val) {
      this.grant = val;
      this.$router.push('/');
    },

    onSubmit: function onSubmit() {
      this.$refs.recaptcha.execute();
    },
    onVerify: function onVerify(response) {
      this.user.captchaToken = response;
    },
    onExpired: function onExpired() {
      console.log('Captcha Expired');
    }
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login_Login__ = __webpack_require__("mJTh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login_Logout__ = __webpack_require__("/Nms");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login_Signup__ = __webpack_require__("zdgq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Login_ResetPassword__ = __webpack_require__("/ruN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Welcome__ = __webpack_require__("FJN/");








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Login_Login__["a" /* default */],
    props: true
  }, {
    path: '/signup',
    name: 'SignUp',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Login_Signup__["a" /* default */]
  }, {
    path: '/home',
    name: 'Welcome',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Welcome__["a" /* default */],
    props: true
  }, {
    path: '/history',
    name: 'History',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "TBpQ"));
    },
    props: true
  }, {
    path: '/report',
    name: 'Report',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "LaaF"));
    },
    props: true
  }, {
    path: '/tasks',
    name: 'Task',
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "TfnA"));
    },
    props: true
  }, {
    path: '/bus/:id',
    name: 'MainContent',
    component: function component() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "h123"));
    },
    props: true
  }, {
    path: '/search',
    name: 'Search',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "+mu8"));
    },
    props: true
  }, {
    path: '/rail/:id',
    name: 'MainContent',
    component: function component() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "h123"));
    },
    props: true
  }, {
    path: '/logout',
    name: 'Logout',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Login_Logout__["a" /* default */]
  }, {
    path: '/resetpassword',
    name: 'Reset',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Login_ResetPassword__["a" /* default */]
  }, {
    path: '/installertasks',
    name: 'Installer Tasks',
    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "sHFV"));
    }
  }, {
    path: '/installation',
    name: 'installation',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "yspC"));
    }
  }, {
    path: '/enablecases',
    name: 'EnableCases',
    component: function component() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "49nd"));
    }
  }],
  mode: 'history'
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Za2f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZqU0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    issues: {
      type: Boolean
    },
    fromTasks: {},
    fromSearch: {
      type: Boolean
    },
    fromInstaller: {
      type: Boolean
    },
    editForm: {
      type: Boolean
    },
    editIssueData: {
      type: Object
    },
    editFromSearch: {
      type: Array
    },
    cr: {
      type: Object
    },
    displayId: {},
    code: {
      type: String
    }
  },
  data: function data() {
    return {
      alertInput: false,
      formTitle: 'Add Issues',
      iconTitle: 'add_circle',
      picUrl: '',
      ticket: '',
      comments: '',
      menuIssuedDate: false,
      menuResolvedDate: false,
      dateIssued: new Date().toISOString(),
      selected: '',
      warning_msg: 'You are about to update multiple entries. Make sure you know the correct job number!!',
      selectIssue: [],
      issue_type: ['Content', 'Display'],
      issueList: [{ issue: 'Broken lock-top' }, { issue: 'Broken lock-bottom' }, { issue: 'Damage number decal' }, { issue: 'Prongs damage/broken' }, { issue: 'Base not bolted down' }, { issue: 'Glass broken' }, { issue: 'Grafitti' }, { issue: 'Diffuser' }, { issue: 'Could Not Access' }, { issue: 'Missing' }, { issue: 'Poster Failling' }, { issue: 'Etching on Film' }, { issue: 'Etching on Metal' }, { issue: 'Aesthetic' }, { issue: 'Wrong PSA' }, { issue: 'Other' }],
      selectHint: 'Content or Display case issue',
      openCloseForms: {
        add: false,
        edit: false,
        task: false,
        search: false,
        searchEdit: false,
        installer: false
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({ currentUser: 'currentUser' })),
  watch: {
    editFromSearch: function editFromSearch() {
      this.formTitle = 'Edit Issues';
      this.iconTitle = 'edit';
      this.selected = this.editFromSearch[0].issue_type;
      this.comments = this.editFromSearch[0].comments;
      this.ticket = this.editFromSearch[0].ticket;
      this.picUrl = this.editFromSearch[0].picture_url;
      this.dateIssued = this.editFromSearch[0].issue_date;
      this.dateResolved = this.editFromSearch[0].resolved_date;
      this.selectIssue = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.editFromSearch[0].issue.data));
      this.openCloseForms.searchEdit = true;
    },
    fromSearch: function fromSearch() {
      this.openCloseForms.search = true;
      this.$validator.reset();
    },
    fromTasks: function fromTasks() {
      console.log('hello');
      this.openCloseForms.task = true;
      this.$validator.reset();
    },
    issues: function issues() {
      this.openCloseForms.add = true;
      this.$refs.form.reset();
      this.$validator.reset();
    },
    fromInstaller: function fromInstaller() {
      this.openCloseForms.installer = true;
      this.$validator.reset();
    },
    editIssueData: function editIssueData() {
      this.formTitle = 'Edit Issues';
      this.iconTitle = 'edit';
      this.selected = this.editIssueData.issue_type;
      this.comments = this.editIssueData.comments;
      this.ticket = this.editIssueData.ticket;
      this.picUrl = this.editIssueData.picture_url;
      this.dateIssued = this.editIssueData.issue_date;
      this.dateResolved = this.editIssueData.resolved_date;
      this.selectIssue = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.editIssueData.issue.data));
      this.openCloseForms.edit = true;
      this.$validator.reset();
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      this.$validator.validateAll().then(function (results) {
        if (results) {
          _this.save();
        } else {
          _this.alertInput = true;
        }
      });
    },
    save: function save() {
      var vm = this;
      if (this.openCloseForms.searchEdit) {
        var payloadSearchEdit = {
          id: this.editFromSearch[0].id,
          displayFk: this.editFromSearch[0].displayFk,
          code: this.code,
          issue_type: this.selected,
          issue: { data: this.selectIssue },
          comments: this.comments,
          picture_url: this.picUrl,
          ticket: this.ticket,
          issue_date: this.dateIssued,
          resolved_date: this.dateResolved
        };
        this.$http.post('/mapsdata/issues/edit', payloadSearchEdit).then(function (response) {
          vm.$validator.reset();
          vm.$refs.form.reset();
          vm.$store.dispatch('closeForm');
          __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit('saveSearchEdit', true);
        });
      }
      if (this.openCloseForms.search) {
        var payloadSearch = {
          data: {
            displayFk: this.displayId,
            code: this.code,
            issue_type: this.selected,
            issue: { data: this.selectIssue },
            comments: this.comments,
            picture_url: this.picUrl,
            ticket: this.ticket,
            issue_date: this.dateIssued,
            resolved_date: this.dateResolved
          },
          fromTask: this.fromTask,
          fromSearch: this.fromSearch
        };
        this.$http.post('/mapsdata/issues/add', payloadSearch).then(function (response) {
          vm.$validator.reset();
          vm.$refs.form.reset();
          vm.$store.dispatch('closeForm');
          __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit('saveSearchEdit', true);
        });
      }
      if (this.openCloseForms.task || this.openCloseForms.installer) {
        var payloadTask = {
          data: {
            displayFk: this.displayId,
            code: this.code,
            issue_type: this.selected,
            issue: { data: this.selectIssue },
            comments: this.comments,
            picture_url: this.picUrl,
            ticket: this.ticket,
            issue_date: this.dateIssued,
            resolved_date: this.dateResolved === undefined ? null : this.dateResolved
          },
          fromTask: this.fromTask,
          fromSearch: this.fromSearch,
          fromInstaller: this.fromInstaller
        };
        this.$http.post('/mapsdata/issues/add', payloadTask).then(function (response) {
          vm.$validator.reset();
          vm.$refs.form.reset();
          __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit('closeFormIssuesTask', { close: false, code: vm.code });
          __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit('saveForm', true);
        });
      }
      if (this.openCloseForms.add) {
        var payload = {
          data: {
            displayFk: this.displayId,
            code: this.code,
            issue_type: this.selected,
            issue: { data: this.selectIssue },
            comments: this.comments,
            picture_url: this.picUrl,
            ticket: this.ticket,
            issue_date: this.dateIssued,
            resolved_date: this.dateResolved
          },
          fromTask: this.fromTask
        };
        this.$http.post('/mapsdata/issues/add', payload).then(function (response) {
          vm.$refs.form.reset();
          __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit('closeFormIssues', false);
          __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit('saveForm', true);
        });
      }
      if (this.openCloseForms.edit) {
        var payloadEdit = {
          id: this.editIssueData.id,
          displayFk: this.displayId,
          code: this.code,
          issue_type: this.selected,
          issue: { data: this.selectIssue },
          comments: this.comments,
          picture_url: this.picUrl,
          ticket: this.ticket,
          issue_date: this.dateIssued,
          resolved_date: this.dateResolved
        };
        this.$http.post('/mapsdata/issues/edit', payloadEdit).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit('closeFormEditIssues', false);
          __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit('saveForm', true);
        });
      }
    },
    resetValues: function resetValues() {
      this.selected = '';
      this.selectIssue = '';
      this.comments = '';
      this.ticket = '';
      this.picUrl = '';
      this.dateIssued = null;
      this.dateResolved = null;
    },
    cancel: function cancel() {
      if (this.openCloseForms.searchEdit) {
        // edits an issue from search component
        this.$validator.reset();
        this.$store.dispatch('closeForm');
      }
      if (this.openCloseForms.search) {
        // adds a new issue from search component
        this.$validator.reset();
        this.$store.dispatch('closeForm');
      }
      if (this.openCloseForms.task) {
        this.$validator.reset();
        this.$refs.form.reset();
        __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit('closeFormIssuesTask', false);
      }
      if (this.openCloseForms.edit) {
        this.$validator.reset();
        __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit('closeFormEditIssues', false);
      }
      if (this.openCloseForms.add) {
        this.$validator.reset();
        this.$refs.form.reset();
        __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit('closeFormIssues', false);
      }
      if (this.openCloseForms.installer) {
        this.$validator.reset();
        this.$refs.form.reset();
        __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit('closeFormIssuesInstaller', false);
      }
    }
  }
});

/***/ }),

/***/ "Zx1r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);


var API_URL = Object({"NODE_ENV":"production"}).API_URL || 'https://amenities.metroservices.io';
var $axios = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: API_URL,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'Authorization': window.localStorage.getItem('token')
  }
});
$axios.interceptors.request.use(function (config) {
  config.headers = {
    'Authorization': window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
  };
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});
/* harmony default export */ __webpack_exports__["a"] = ($axios);

/***/ }),

/***/ "aGBW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{staticClass:"mb-3",attrs:{"row":""}},[_c('div',[_c('h1',{staticClass:"mb-4 header display-1"},[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('p',[_vm._v("\n         This application manages all the display cases and its content available through LA Metro Rail system, Orange and Silver Lines."),_c('br')])])]),_vm._v(" "),_c('v-layout',{staticClass:"mb-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('h3',{staticClass:"title"},[_vm._v("To get started please select one of the options below or a Metro Location")])])],1),_vm._v(" "),_c('v-layout',_vm._b({attrs:{"row":"","wrap":""}},'v-layout',_vm.binding,false),_vm._l((_vm.menuItems1),function(item,index){return _c('v-flex',{key:index,staticClass:"ma-2 pa-0",attrs:{"xs3":"","sm3":"","id":"cards"}},[_c('v-card',{staticClass:"pa-0"},[_c('v-layout',[_c('v-flex',{staticClass:"ma-0 pa-0",attrs:{"xs12":""}},[_c('v-list',{staticClass:"pa-0",attrs:{"three-line":""}},[_c('v-list-tile',{staticClass:"pt-0",attrs:{"to":item.href}},[_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"pt-3",attrs:{"large":""}},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.description))])],1)],1)],1)],1)],1)],1)],1)}),1),_vm._v(" "),_c('v-layout',{staticClass:"mt-3 mb-3",attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('h3',{staticClass:"title"},[_vm._v("Metro Locations")]),_vm._v(" "),_c('span',{staticClass:"subheding"},[_vm._v("See all available content by location")])])],1),_vm._v(" "),_c('v-layout',_vm._b({attrs:{"row":"","wrap":""}},'v-layout',_vm.binding,false),_vm._l((_vm.menuItems2),function(item,index){return _c('v-flex',{key:index,staticClass:"ma-2 pa-0",attrs:{"xs3":"","sm3":""}},[_c('v-card',{staticClass:"pa-0"},[_c('v-layout',[_c('v-flex',{staticClass:"ma-0 pa-0",attrs:{"xs12":""}},[_c('v-list',{staticClass:"pa-0"},[_c('v-list-tile',{staticClass:"pa-0",attrs:{"to":item.href}},[_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"pt-0",attrs:{"large":"","color":item.color}},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)],1)],1)],1)],1)],1)],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ahu/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-0",attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs11":"","sm12":"","md12":""}},[_c('h4',{staticClass:"display-1",style:(_vm.findRailBusName(this.$route.params.id))},[_vm._v(_vm._s(_vm.railname)+" "),_c('v-icon',{style:(_vm.findRailBusName(this.$route.params.id)),attrs:{"large":"","id":"iconTitle"}},[_vm._v(_vm._s(_vm.iconVal))])],1),_vm._v(" "),_c('display-selector',{attrs:{"data":_vm.displayData,"railId":_vm.dataObj.id,"showBtn":_vm.toggleBtn,"cr":_vm.findRailBusName(this.$route.params.id)},on:{"selectedItem":_vm.showMaps,"toggleBtn":_vm.tgBtn}}),_vm._v(" "),(_vm.toogleGrid)?[_c('display-grid',{attrs:{"dat":_vm.displayResults,"mapsData":_vm.data,"issues":_vm.issuesDat,"railId":_vm.dataObj.id,"showButton":_vm.showButton,"cr":_vm.findRailBusName(this.$route.params.id),"showDisplayCaseSelector":_vm.showCaseSelector}})]:_vm._e()],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aq6Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm10":"","md8":"","lg6":""}},[_c('v-card',[_c('v-alert',{attrs:{"dismissible":"","type":"error"},model:{value:(_vm.alertInput),callback:function ($$v) {_vm.alertInput=$$v},expression:"alertInput"}},[_vm._v("\n                    'Upps something is wrong! Please correct the mistakes'\n                  ")]),_vm._v(" "),_c('v-toolbar',{attrs:{"color":_vm.cr.colorName,"prominent":""}},[_c('v-toolbar-title',{staticClass:"body-3 white--text"},[_vm._v(_vm._s(_vm.formTitle)+"\n                        "),_c('v-icon',{staticClass:"pl-2",attrs:{"color":"white"}},[_vm._v(_vm._s(_vm.iconTitle))])],1),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-form',{ref:"form"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input-group--focused",attrs:{"items":_vm.issue_type,"label":"Issue Type","input":"selected","item-value":"text","hint":_vm.selectHint,"persistent-hint":"","error-messages":_vm.errors.collect('selected'),"required":"","data-vv-name":"selected"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1),_vm._v(" "),_c('h4',{staticClass:"mt-3 subheading font-weight-light"},[_vm._v("Select the issues you want to report")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.issueList),function(i){return _c('v-flex',{key:i.issue,attrs:{"xs6":""}},[_c('v-checkbox',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":i.issue,"value":i.issue,"name":"issues","error-messages":_vm.errors.collect('issues'),"data-vv-name":"issues"},model:{value:(_vm.selectIssue),callback:function ($$v) {_vm.selectIssue=$$v},expression:"selectIssue"}})],1)}),1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('v-textarea',{directives:[{name:"validate",rawName:"v-validate",value:('max:500'),expression:"'max:500'"}],attrs:{"label":"Comments","hint":"Comments about any issues","persistent-hint":"","outline":"","error-messages":_vm.errors.collect('comments'),"data-vv-name":"comments"},model:{value:(_vm.comments),callback:function ($$v) {_vm.comments=$$v},expression:"comments"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Picture url"},model:{value:(_vm.picUrl),callback:function ($$v) {_vm.picUrl=$$v},expression:"picUrl"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Ticket#"},model:{value:(_vm.ticket),callback:function ($$v) {_vm.ticket=$$v},expression:"ticket"}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-4",attrs:{"row":""}},[_c('v-flex',[_c('v-btn',{staticClass:"white--text",attrs:{"color":_vm.cr.colorName},on:{"click":function($event){return _vm.submit()}}},[_vm._v("Save "),_c('v-icon',{staticClass:"pl-1",attrs:{"color":"white"}},[_vm._v("check_circle")])],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":_vm.cr.colorName},on:{"click":_vm.cancel}},[_vm._v("Cancel"),_c('v-icon',{staticClass:"pl-1",attrs:{"color":"white"}},[_vm._v("cancel")])],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b1T4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-0 pa-0",attrs:{"fluid":""}},[_c('v-layout',{staticClass:"pa-0"},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_vm._l((_vm.dat),function(data){return _c('v-card',{key:data.id,staticClass:"mb-5"},[_c('v-toolbar',{attrs:{"card":"","color":_vm.cr.colorName,"prominent":""}},[_c('v-menu',{attrs:{"bottom":"","fixed":"","offset-y":"","nudge-top":"5","max-width":"500px","open-on-hover":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',{attrs:{"color":"white","dark":""}},[_vm._v("info")])],1),_vm._v(" "),_c('v-list',[_c('v-subheader',[_vm._v("Display Case Information")]),_vm._v(" "),_c('v-subheader',{staticClass:" text-truncate caption"},[_vm._v(_vm._s(data.portal_name))]),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"body-1 text-trucate"},[_c('span',[_vm._v("Display Code:")]),_vm._v(" "+_vm._s(data.code))])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"body-1 text-trucate"},[_c('span',[_vm._v("Display Type:")]),_vm._v(" "+_vm._s(data.displayType))])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"body-1 text-trucate"},[_c('span',[_vm._v("Size:")]),_vm._v(" "+_vm._s(data.size))])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"body-1 text-trucate"},[_c('span',[_vm._v("Location:")]),_vm._v(" "+_vm._s(data.loc_descrp))])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"body-1 text-trucate"},[_c('span',[_vm._v("Status:")]),_vm._v(" "+_vm._s(data.status))])],1)],1)],1)],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"body-1 white--text sub"},[_vm._v("Case Code: "+_vm._s(data.code))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","icon":"","color":_vm.cr.colorName},on:{"click":function($event){$event.stopPropagation();return _vm.issuesInfo(data.code, data.id)}},slot:"activator"},[_c('v-icon',[_vm._v("fas fa-flag")])],1),_vm._v(" "),_c('span',[_vm._v("Report an Issue")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","icon":"","color":_vm.cr.colorName},on:{"click":function($event){$event.stopPropagation();return _vm.editDisplayInfo(data)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('span',[_vm._v("Edit Display")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","icon":"","color":_vm.cr.colorName},on:{"click":function($event){$event.stopPropagation();return _vm.addInfo(data)}},slot:"activator"},[_c('v-icon',[_vm._v("add_circle")])],1),_vm._v(" "),_c('span',[_vm._v("Add Display Graphic")])],1)],1),_vm._v(" "),_c('v-container',{staticClass:"pt-4 px-0",attrs:{"fluid":""}},[_c('v-card-text',{staticClass:"pa-0"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg":"","12":""}},[_c('v-data-table',{staticClass:"pa-0",attrs:{"light":"","headers":_vm.heads,"items":_vm.arr(data.displayId),"hide-actions":"","expand":_vm.expand,"pagination":_vm.pagination},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{on:{"click":function($event){return _vm.showNotes(props)}}},[_c('td',{staticClass:"text-xs-left pt-2"},[_vm._v(_vm._s(props.item.title))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left pt-2"},[_vm._v(_vm._s(props.item.jobNum))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left pt-2"},[_vm._v(_vm._s(props.item.status)+"\n                              "),(props.item.status === 'Pending')?[_c('v-icon',{staticClass:"pl-1",attrs:{"small":"","color":"red"}},[_vm._v(" fas fa-exclamation-triangle ")])]:_vm._e()],2),_vm._v(" "),_c('td',{staticClass:"text-xs-left pt-2"},[_vm._v(_vm._s(props.item.date))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left pt-2"},[_vm._v(_vm._s(props.item.postby))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left pt-2"},[_vm._v(_vm._s(props.item.install_date))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left pt-2"},[_vm._v(_vm._s(props.item.qc_date))]),_vm._v(" "),_c('td',[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","fab":"","small":""},on:{"click":function($event){return _vm.changeStatus('ins')}},slot:"activator"},[_c('v-icon',{attrs:{"small":""}},[_vm._v("fas fa-check-square")])],1),_vm._v(" "),_c('span',[_vm._v("Installed")])],1),_vm._v(" "),(_vm.currentUser.id === 17 || _vm.currentUser.id === 1 || _vm.currentUser.id === 6)?[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","fab":"","small":""},on:{"click":function($event){return _vm.changeStatus('qc')}},slot:"activator"},[_c('v-icon',{attrs:{"small":""}},[_vm._v("fas fa-user-check")])],1),_vm._v(" "),_c('span',[_vm._v("QC verified")])],1)]:_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","value":props.item.serialCode},nativeOn:{"click":function($event){return _vm.editMapInfo(props.item, data)}},slot:"activator"},[_c('v-icon',{attrs:{"small":""}},[_vm._v("fas fa-edit")])],1),_vm._v(" "),_c('span',[_vm._v("Edit Information")])],1)],2)]),_vm._v(" "),(props.item.notes !== null)?_c('tr',[_c('td',{attrs:{"colspan":_vm.heads.length}},[_c('p',[_c('b',[_vm._v("Notes for "+_vm._s(props.item.jobNum)+": ")]),_vm._v(_vm._s(props.item.notes))])])]):_vm._e()]}}],null,true)})],1)],1)],1)],1)],1)}),_vm._v(" "),(_vm.issues.length !== 0)?[_c('v-card',[_c('v-toolbar',{attrs:{"card":"","color":_vm.cr.colorName,"prominent":""}},[_c('v-toolbar-title',{staticClass:"body-1 white--text sub"},[_c('v-icon',{staticClass:"pl-1",attrs:{"small":"","color":"red"}},[_vm._v(" fas fa-exclamation-triangle ")]),_vm._v(" Issues\n              ")],1)],1),_vm._v(" "),_c('v-container',{staticClass:"pt-4 px-0",attrs:{"fluid":""}},[_c('v-card-text',{staticClass:"pa-0"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg":"","12":""}},[_c('v-data-table',{staticClass:"pa-0",attrs:{"items":_vm.issues,"light":"","headers":_vm.issueHeaders,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left pt-2"},[_vm._v(_vm._s(props.item.issue_type))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left pt-2"},_vm._l((_vm.getIssues(props.item.issue)),function(i){return _c('span',{key:i},[_vm._v("\n                                "+_vm._s(i)+" "),_c('br')])}),0),_vm._v(" "),_c('td',{staticClass:"text-xs-left pt-2"},[_vm._v(_vm._s(props.item.comments))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left pt-2"},[_vm._v(_vm._s(props.item.ticket))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left pt-2"},[_c('a',{attrs:{"href":props.item.picture_url,"target":"_blank"}},[_vm._v(_vm._s(props.item.picture_url))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left pt-2"},[_vm._v(_vm._s(props.item.issue_date))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left pt-2"},[_vm._v(_vm._s(props.item.resolved_date))]),_vm._v(" "),_c('td',[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","value":props.item.serialCode},nativeOn:{"click":function($event){return _vm.editIssue(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"small":""}},[_vm._v("fas fa-edit")])],1),_vm._v(" "),_c('span',[_vm._v("Edit Issue")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","value":props.item.serialCode},nativeOn:{"click":function($event){return _vm.resolvedIssue(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"small":""}},[_vm._v("fas fa-check")])],1),_vm._v(" "),_c('span',[_vm._v("Close Issue")])],1)],1)]}}],null,false,4077701807)})],1)],1)],1)],1)],1)]:_vm._e()],2)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","scrollable":"","transition":"dialog-bottom-transition","overlay":false,"full-width":""},model:{value:(_vm.openFormIssues),callback:function ($$v) {_vm.openFormIssues=$$v},expression:"openFormIssues"}},[_c('v-card',{attrs:{"height":"1500px"}},[_c('v-toolbar',{staticClass:"white--text",staticStyle:{"flex":"0 0 auto"},attrs:{"color":_vm.cr.colorName}},[_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.openFormIssues = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Report Form")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('formAddIssues',{attrs:{"issues":_vm.openFormIssues,"cr":_vm.cr,"code":_vm.eCode,"displayId":_vm.eDisplayId}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","scrollable":"","transition":"dialog-bottom-transition","overlay":false,"full-width":""},model:{value:(_vm.openFormEditIssues),callback:function ($$v) {_vm.openFormEditIssues=$$v},expression:"openFormEditIssues"}},[_c('v-card',{attrs:{"height":"1500px"}},[_c('v-toolbar',{staticClass:"white--text",staticStyle:{"flex":"0 0 auto"},attrs:{"color":_vm.cr.colorName}},[_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.openFormEditIssues = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Report Form")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('formAddIssues',{attrs:{"issues":false,"editForm":_vm.editIssueForm,"editIssueData":_vm.editIssueInfo,"cr":_vm.cr,"code":_vm.eCode,"displayId":_vm.eDisplayId}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","scrollable":"","transition":"dialog-bottom-transition","overlay":false},model:{value:(_vm.openFormAddMap),callback:function ($$v) {_vm.openFormAddMap=$$v},expression:"openFormAddMap"}},[_c('v-card',{staticStyle:{"height":"1361px"}},[_c('v-toolbar',{staticClass:"white--text",staticStyle:{"flex":"0 0 auto"},attrs:{"color":_vm.cr.colorName}},[_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.openFormAddMap = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Form")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('formAddMap',{attrs:{"add":_vm.openFormAddMap,"addData":_vm.addDat,"cr":_vm.cr}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","transition":"dialog-bottom-transition","overlay":false,"scrollable":""},model:{value:(_vm.editMap),callback:function ($$v) {_vm.editMap=$$v},expression:"editMap"}},[_c('v-card',{staticStyle:{"height":"1361px"}},[_c('v-toolbar',{staticClass:"white--text",staticStyle:{"flex":"0 0 auto"},attrs:{"color":_vm.cr.colorName}},[_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.editMap = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Form")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('formAddMap',{attrs:{"edit":_vm.editData,"addData":_vm.addDat,"cr":_vm.cr}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","transition":"dialog-bottom-transition","overlay":true},model:{value:(_vm.openFormEditDisplay),callback:function ($$v) {_vm.openFormEditDisplay=$$v},expression:"openFormEditDisplay"}},[_c('v-card',[_c('v-toolbar',{staticClass:"white--text",staticStyle:{"flex":"0 0 auto"},attrs:{"color":_vm.cr.colorName}},[_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.openFormEditDisplay = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Form")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('formAddDisplay',{attrs:{"displayEdit":_vm.editDisplayData,"hideAdd":_vm.hideAdd,"id":_vm.valueId,"cr":_vm.cr,"readonly":true}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.openDialog),callback:function ($$v) {_vm.openDialog=$$v},expression:"openDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"error white--text"},[_c('v-icon',{staticClass:"white--text pr-3"},[_vm._v("warning")]),_c('span',[_vm._v("Something is wrong...")]),_vm._v(" "),_c('v-icon',{staticClass:"white--text pl-2"},[_vm._v("fa-frown-o")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v(_vm._s(_vm.errorMsg))])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.openDialog=false}}},[_vm._v("Close")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bSYI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Issues_vue__ = __webpack_require__("ZqU0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9a58e66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Issues_vue__ = __webpack_require__("aq6Q");
function injectStyle (ssrContext) {
  __webpack_require__("Obwe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Issues_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9a58e66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Issues_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "byRY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Forms_AddMap__ = __webpack_require__("qpoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Forms_AddDisplay__ = __webpack_require__("o/i4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Forms_Issues__ = __webpack_require__("bSYI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dat: {
      type: Array
    },
    mapsData: {
      type: Array
    },
    railId: {
      type: String
    },
    cr: {
      type: Object
    },
    addSwitch: {
      type: Boolean
    },
    issues: {
      type: Array
    }
  },
  components: {
    formAddMap: __WEBPACK_IMPORTED_MODULE_2__Forms_AddMap__["a" /* default */],
    formAddDisplay: __WEBPACK_IMPORTED_MODULE_3__Forms_AddDisplay__["a" /* default */],
    formAddIssues: __WEBPACK_IMPORTED_MODULE_4__Forms_Issues__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])({
    currentUser: 'currentUser',
    showDisplay: 'showDisplay'
  })),
  data: function data() {
    return {
      pagination: {
        sortBy: 'jobNum',
        descending: true
      },
      noteMsg: { msg: '', jobnum: '' },
      openDialog: false,
      eCode: '',
      expand: false,
      eDisplayId: '',
      errorMsg: '',
      color: '',
      selected: [],
      show: false,
      hideAdd: false,
      editData: {},
      showForm: false,
      editDisplayData: {},
      editDisplay: {},
      editIssueInfo: {},
      addDat: {},
      valueId: '',
      editIssueForm: false,
      editMap: false,
      openFormIssues: false,
      openFormEditIssues: false,
      openFormAddMap: false,
      openFormEditDisplay: false,
      displayData: this.dat,
      heads: [{ text: 'Title', value: 'title', align: 'left' }, { text: 'Job Number', value: 'jobNum', align: 'left' }, { text: 'Status', value: 'status', align: 'left' }, { text: 'Last Update', value: 'date', align: 'left' }, { text: 'Post By', value: 'postby', align: 'left' }, { text: 'Installed on', value: 'install_date', align: 'left' }, { text: 'QC on', value: 'qc_date', align: 'left' }, { text: 'Actions', value: 'action', align: 'left' }],
      issueHeaders: [{ text: 'Issue Type', value: 'issue_type', align: 'left' }, { text: 'Issues', value: 'issue', align: 'left' }, { text: 'Comments', value: 'comments', align: 'left' }, { text: 'Ticket#', value: 'ticket', align: 'left' }, { text: 'Picture Url', value: 'picture_url', align: 'left' }, { text: 'Issue Date', value: 'issue_date', align: 'left' }, { text: 'Resolved Date', value: 'resolved_date', align: 'left' }, { text: 'Actions', value: 'action', align: 'left' }],
      items: ''
    };
  },

  watch: {
    dat: function dat() {
      this.dat = this.dat;
      this.noteMsg.msg = '';
      this.noteMsg.jobnum = '';
    }
  },
  created: function created() {
    var vm = this;
    __WEBPACK_IMPORTED_MODULE_5__main__["bus"].$on('closeForm', function (data, editInfo) {
      // edit maps from search
      if (data.edit === true) {
        vm.editMap = false;
      }
      if (data.add === true) {
        vm.openFormAddMap = false;
      }
    });
    __WEBPACK_IMPORTED_MODULE_5__main__["bus"].$on('closeFormEditIssues', function (data) {
      vm.openFormEditIssues = data;
    });
    __WEBPACK_IMPORTED_MODULE_5__main__["bus"].$on('closeFormIssues', function (data) {
      vm.openFormIssues = data;
    });
    __WEBPACK_IMPORTED_MODULE_5__main__["bus"].$on('closeFormDisplayEdit', function (data) {
      vm.openFormEditDisplay = data;
    });
    __WEBPACK_IMPORTED_MODULE_5__main__["bus"].$on('closeSaveFormEdit', function (data) {
      vm.openFormEditDisplay = data;
    });
  },

  methods: {
    showNotes: function showNotes(item) {
      item.expanded = false;
      this.expand = false;
    },
    getIssues: function getIssues(item) {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(item.data));
    },
    noteFooter: function noteFooter(item) {
      if (item.status === 'Active' || item.status === 'Pending') {
        this.noteMsg.msg = item.notes;
        this.noteMsg.jobnum = item.jobNum;
      }
    },
    editIssue: function editIssue(data) {
      this.editIssueInfo = [];
      this.openFormEditIssues = true;
      this.editIssueForm = true;
      this.editIssueInfo = data;
      this.eCode = data.code;
      this.eDisplayId = data.displayFk;
    },
    resolvedIssue: function resolvedIssue(data) {
      var url = 'mapsdata/issues/resolved/';
      this.$http.post(url, {
        code: data.code,
        id: data.id,
        date: new Date().toISOString()
      }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_5__main__["bus"].$emit('saveForm', data);
      });
    },
    issuesInfo: function issuesInfo(data, data2) {
      this.openFormIssues = true;
      this.eCode = data;
      this.eDisplayId = data2;
    },
    findStatusPending: function findStatusPending(type) {
      if (type === 'qc') {
        return this.mapsData.filter(function (map) {
          return map.qc_date === null && map.status !== 'Expired';
        });
      }
      return this.mapsData.filter(function (map) {
        return map.status === 'Pending';
      });
    },
    changeStatus: function changeStatus(type) {
      var data = this.findStatusPending(type);
      var obj = data[0];
      this.errorMsg = '';
      var url = 'mapsdata/map/updatestatus';
      if (data.length !== 0) {
        if (type === 'qc') {
          this.$http.post(url, {
            qc: true,
            installer: false,
            map_id: obj.id,
            code: obj.serialCode,
            date: new Date().toISOString()
          }).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_5__main__["bus"].$emit('saveForm', data);
          });
        } else {
          this.$http.post(url, {
            qc: false,
            installer: true,
            map_id: obj.id,
            status: 'Active',
            isInstall: 'Yes',
            code: obj.serialCode,
            date: new Date().toISOString()
          }).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_5__main__["bus"].$emit('saveForm', data);
          });
        }
      } else {
        this.openDialog = true;
        this.errorMsg = 'You can only modify pending or active items.';
      }
    },
    checkNotes: function checkNotes(id) {
      return this.countNotes(id);
    },
    editMapInfo: function editMapInfo(serialCode, displayDat) {
      this.editMap = true;
      this.editData = serialCode;
      this.addDat = displayDat;
    },
    addInfo: function addInfo(info) {
      this.openFormAddMap = true;
      this.addDat = info;
      this.hideAdd = false;
    },
    editDisplayInfo: function editDisplayInfo(dat) {
      this.openFormEditDisplay = true;
      this.editDisplayData = dat;
      this.noEdit = false;
      this.hideAdd = true;
    },
    closeDialog: function closeDialog(flag) {
      this.editMap = flag;
    },
    findTitle: function findTitle(id) {
      var vm = this;
      var a = '';
      vm.data.forEach(function (d) {
        if (d.id === id) {
          a = d.name;
        }
      });
      return a;
    },
    arr: function arr(id) {
      var vm = this;
      var arr = [];
      vm.mapsData.forEach(function (m) {
        if (m.displayFk === id) {
          arr.push(m);
        }
      });
      return arr;
    },
    setvalueid: function setvalueid(id) {
      this.openNotes = true;
      this.valueId = id;
    }
  }
});

/***/ }),

/***/ "cILH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dfk4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backend_vue_axios_axios_js__ = __webpack_require__("Zx1r");

var state = {
  pending: null,
  complete: null,
  taskDates: null,
  tasksByDate: null,
  tasks: null,
  installerTasks: null,
  installerComplete: null,
  stations: null,
  numComplete: 0
};
var mutations = {
  setTasks: function setTasks(state, payload) {
    state.tasks = payload;
  },
  setStations: function setStations(state, payload) {
    state.stations = payload;
  },
  setPending: function setPending(state, payload) {
    state.pending = payload;
  },
  setTaskDates: function setTaskDates(state, payload) {
    state.taskDates = payload;
  },
  setTasksByDates: function setTasksByDates(state, payload) {
    state.tasksByDate = payload;
  },
  setComplete: function setComplete(state, payload) {
    state.complete = payload;
  },
  setInstallerComplete: function setInstallerComplete(state, payload) {
    state.installerComplete = payload;
  },
  setInstallerTasks: function setInstallerTasks(state, payload) {
    state.installerTasks = payload;
  },
  resetPendingState: function resetPendingState(state) {
    state.pending = null;
  },
  resetCompleteState: function resetCompleteState(state) {
    state.complete = [];
  },
  resetStations: function resetStations(state) {
    state.stations = null;
  },
  resetTasks: function resetTasks(state) {
    state.tasks = null;
  },
  removeTask: function removeTask(state, payload) {
    state.complete.push(payload.item);
    state.pending = state.pending.filter(function (i) {
      return payload.item.serialCode !== i.serialCode;
    });
  },
  removeComplete: function removeComplete(state, payload) {
    state.pending.push(payload.item);
    state.complete = state.complete.filter(function (i) {
      return payload.item.serialCode !== i.serialCode;
    });
  }
};

var getters = {
  getPendingTasks: function getPendingTasks(state) {
    return state.pending;
  },
  getCompleteTasks: function getCompleteTasks(state) {
    return state.complete;
  },
  getInstallerTasks: function getInstallerTasks(state) {
    return state.installerTasks;
  },
  getInstallerComplete: function getInstallerComplete(state) {
    return state.installerComplete;
  },
  getTaskDates: function getTaskDates(state) {
    return state.taskDates;
  },
  getTasksByDates: function getTasksByDates(state) {
    return state.tasksByDate;
  },
  getStations: function getStations(state) {
    return state.stations;
  },
  getTasks: function getTasks(state) {
    return state.tasks;
  }
};

var actions = {
  getTasks: function getTasks(_ref, payload) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_0__backend_vue_axios_axios_js__["a" /* default */].get(payload.urlPending).then(function (response) {
      commit('setPending', response.data);
      __WEBPACK_IMPORTED_MODULE_0__backend_vue_axios_axios_js__["a" /* default */].get(payload.urlComplete).then(function (response) {
        commit('setComplete', response.data);
      });
    });
  },
  getInstallerData: function getInstallerData(_ref2, payload) {
    var commit = _ref2.commit;

    __WEBPACK_IMPORTED_MODULE_0__backend_vue_axios_axios_js__["a" /* default */].get(payload.urlComplete).then(function (response) {
      commit('setInstallerComplete', response.data);
      __WEBPACK_IMPORTED_MODULE_0__backend_vue_axios_axios_js__["a" /* default */].get(payload.urlPending).then(function (response) {
        commit('setInstallerTasks', response.data);
      });
    });
  },
  getInstallerTasks: function getInstallerTasks(_ref3, payload) {
    var commit = _ref3.commit;

    __WEBPACK_IMPORTED_MODULE_0__backend_vue_axios_axios_js__["a" /* default */].get(payload.urlPending).then(function (response) {
      commit('setInstallerTasks', response.data);
    });
  },
  getInstallerComplete: function getInstallerComplete(_ref4, payload) {
    var commit = _ref4.commit;

    commit('setInstallerComplete', payload);
  },
  completeTask: function completeTask(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    __WEBPACK_IMPORTED_MODULE_0__backend_vue_axios_axios_js__["a" /* default */].post(payload.url, payload.obj).then(function (response) {
      dispatch('fetchInstallersTasks', { url: payload.url2 });
    });
  },
  undoComplete: function undoComplete(_ref6, payload) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;

    __WEBPACK_IMPORTED_MODULE_0__backend_vue_axios_axios_js__["a" /* default */].post(payload.url, payload.obj).then(function (response) {
      dispatch('fetchInstallersTasks', { url: payload.url2 });
    });
  },
  loadStations: function loadStations(_ref7, payload) {
    var commit = _ref7.commit;

    __WEBPACK_IMPORTED_MODULE_0__backend_vue_axios_axios_js__["a" /* default */].get(payload.url).then(function (response) {
      commit('resetTasks');
      commit('resetStations');
      commit('setStations', response.data);
    });
  },
  fetchInstallersTasks: function fetchInstallersTasks(_ref8, payload) {
    var commit = _ref8.commit;

    __WEBPACK_IMPORTED_MODULE_0__backend_vue_axios_axios_js__["a" /* default */].get(payload.url).then(function (response) {
      commit('resetTasks');
      commit('setTasks', response.data);
    });
  },
  resetTasks: function resetTasks(_ref9) {
    var commit = _ref9.commit;

    commit('resetTasks');
    commit('resetStations');
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
});

/***/ }),

/***/ "g67T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gRp0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode__ = __webpack_require__("ytdl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jwt_decode__);




var User = function () {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(User, null, [{
    key: 'from',
    value: function from(token) {
      try {
        var obj = __WEBPACK_IMPORTED_MODULE_2_jwt_decode___default()(token);
        return new User(obj);
      } catch (_) {
        return null;
      }
    }
  }]);

  function User(_ref) {
    var user_id = _ref.user_id,
        firstname = _ref.firstname,
        lastname = _ref.lastname,
        email = _ref.email,
        exp = _ref.exp;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, User);

    this.id = user_id;
    this.firstname = firstname;
    this.lastname = lastname;
    this.email = email;
    this.exp = exp;
  }

  return User;
}();

/* harmony default export */ __webpack_exports__["a"] = (User);

/***/ }),

/***/ "h123":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainContent_vue__ = __webpack_require__("Qk/z");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c02c8fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainContent_vue__ = __webpack_require__("ahu/");
function injectStyle (ssrContext) {
  __webpack_require__("xJtk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c02c8fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c02c8fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "h9wt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Logout',
  created: function created() {
    delete localStorage.token;
    this.$store.dispatch('logout');
    this.$router.push('/');
  }
});

/***/ }),

/***/ "jnyb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backend_vue_axios_axios_js__ = __webpack_require__("Zx1r");


var state = {
  logs: []
};

var mutations = {
  setLogs: function setLogs(state, payload) {
    payload.forEach(function (i) {
      i.userId.forEach(function (ui) {
        ui.email = i.email;
        state.logs.push(ui);
      });
    });
  },
  clearLogState: function clearLogState(state) {
    state.logs = [];
  }
};
var getters = {
  getLogs: function getLogs(state) {
    return state.logs;
  }
};
var actions = {
  callLogs: function callLogs(_ref, payload) {
    var commit = _ref.commit;

    var url = payload;
    commit('clearLogState');
    __WEBPACK_IMPORTED_MODULE_0__backend_vue_axios_axios_js__["a" /* default */].get(url).then(function (response) {
      commit('setLogs', response.data);
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
});

/***/ }),

/***/ "jwGj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_User__ = __webpack_require__("gRp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__("Du/2");


var _mutations;




var state = {
  user: __WEBPACK_IMPORTED_MODULE_1__models_User__["a" /* default */].from(window.localStorage.getItem('token')),
  showMenu: false
};
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* LOGIN */], function (state) {
  state.user = __WEBPACK_IMPORTED_MODULE_1__models_User__["a" /* default */].from(window.localStorage.getItem('token'));
  state.showMenu = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* LOGOUT */], function (state) {
  state.user = null;
  state.showMenu = false;
}), _mutations);

var getters = {
  currentUser: function currentUser(state) {
    return state.user;
  },
  menuStatus: function menuStatus(state) {
    return state.showMenu;
  }
};

var actions = {
  login: function login(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* LOGIN */]);
  },
  logout: function logout(_ref2) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* LOGOUT */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
});

/***/ }),

/***/ "l0b2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backend_vue_axios_axios_js__ = __webpack_require__("Zx1r");


var state = {
  verified: null,
  complete: null
};

var mutations = {
  setVerifiedEmail: function setVerifiedEmail(state, payload) {
    state.verified = payload;
  },
  passSet: function passSet(state, payload) {
    state.complete = payload;
  },
  clearState: function clearState(state) {
    state.verified = null;
    state.complete = null;
  }
};

var getters = {
  isVerified: function isVerified(state) {
    return state.verified;
  },
  isPasswordSet: function isPasswordSet(state) {
    return state.complete;
  }
};

var actions = {
  checkEmail: function checkEmail(_ref, payload) {
    var commit = _ref.commit,
        state = _ref.state;

    var url = payload;
    __WEBPACK_IMPORTED_MODULE_0__backend_vue_axios_axios_js__["a" /* default */].post(url.url, { email: url.email }).then(function (response) {
      commit('setVerifiedEmail', response.data.msg);
    });
  },
  setNewPassword: function setNewPassword(_ref2, payload) {
    var commit = _ref2.commit;

    var url = payload;
    __WEBPACK_IMPORTED_MODULE_0__backend_vue_axios_axios_js__["a" /* default */].post(url.url, { password: url.password, email: url.email, captchaToken: url.recaptchaToken }).then(function (response) {
      commit('passSet', response.data.msg);
    });
  },
  resetState: function resetState(_ref3) {
    var commit = _ref3.commit;

    commit('clearState');
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
});

/***/ }),

/***/ "laec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backend_vue_axios_axios_js__ = __webpack_require__("Zx1r");

var state = {
  searchResults: null,
  saveBulkEdit: { status: null, msg: '' },
  saveSearch: { status: null, msg: '' },
  formsManagement: {
    update: false,
    edit: false,
    issues: false,
    editContent: false,
    editIssues: false
  }
};
var mutations = {
  clearState: function clearState(state) {
    state.searchResults = null;
  },
  setSearchResults: function setSearchResults(state, payload) {
    state.searchResults = payload;
  },
  setSaveBulkEdit: function setSaveBulkEdit(state, payload) {
    state.saveBulkEdit.status = true;
    state.saveBulkEdit.msg = payload;
  },
  setSaveSearch: function setSaveSearch(state, payload) {
    state.saveSearch.status = true;
    state.saveSearch.msg = payload;
  },
  setFormStatus: function setFormStatus(state, payload) {
    state.formsManagement.update = payload.update;
    state.formsManagement.edit = payload.edit;
    state.formsManagement.editContent = payload.editContent;
    state.formsManagement.issues = payload.issues;
    state.formsManagement.editIssues = payload.editIssues;
  },
  resetFormStatus: function resetFormStatus(state) {
    state.formsManagement = {
      update: false,
      edit: false,
      issues: false,
      editContent: false,
      editIssues: false
    };
  }
};
var getters = {
  isSaveBulkEdit: function isSaveBulkEdit(state) {
    return state.saveBulkEdit;
  },
  isSaveSearch: function isSaveSearch(state) {
    return state.saveSearch;
  },
  getSearchResults: function getSearchResults(state) {
    return state.searchResults;
  },
  getFormStatus: function getFormStatus(state) {
    return state.formsManagement;
  }
};
var actions = {
  searchObject: function searchObject(_ref, payload) {
    var commit = _ref.commit;

    var url = payload;
    commit('clearState');
    __WEBPACK_IMPORTED_MODULE_0__backend_vue_axios_axios_js__["a" /* default */].get(url).then(function (response) {
      commit('setSearchResults', response.data);
    }).catch(function (error) {
      console.log(error);
    });
  },
  resetStatus: function resetStatus(_ref2) {
    var commit = _ref2.commit;

    commit('resetFormStatus');
  },
  closeForm: function closeForm(_ref3) {
    var commit = _ref3.commit;

    commit('resetFormStatus');
  },
  openForm: function openForm(_ref4, payload) {
    var commit = _ref4.commit;

    commit('setFormStatus', payload);
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
});

/***/ }),

/***/ "mAUx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mJTh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("04Xd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c6f2716_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("MXwS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c6f2716_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "npIG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_recaptcha__ = __webpack_require__("olAn");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Reset',
  components: {
    captcha: __WEBPACK_IMPORTED_MODULE_2_vue_recaptcha__["a" /* default */]
  },
  data: function data() {
    return {
      siteKey: '6LckcoUUAAAAAADvzeIYlFgM7XyhZqaTPUx-upzK',
      stp: 0,
      email: '',
      password: '',
      confirmPassword: '',
      openDialog: false,
      errorMsg: '',
      show1: false,
      show2: false,
      rules: {
        required: function required(value) {
          return !!value || 'Required.';
        },
        min: function min(v) {
          return v.length >= 8 || 'Min 8 characters';
        }
      },
      captchaToken: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    isVerified: 'isVerified',
    isPasswordSet: 'isPasswordSet'
  })),
  watch: {
    isVerified: function isVerified() {
      if (this.isVerified) {
        this.stp++;
      } else {
        this.openDialog = true;
        this.email = '';
        this.errorMsg = 'Your e-mail is not in the Database';
        this.$store.dispatch('resetState');
      }
    },
    isPasswordSet: function isPasswordSet() {
      if (this.isPasswordSet) {
        this.stp++;
      } else {
        this.openDialog = true;
        this.errorMsg = 'Password does not match!';
      }
    }
  },
  methods: {
    verifyEmail: function verifyEmail() {
      if (this.email !== '') {
        this.$store.dispatch('checkEmail', {
          email: this.email,
          url: 'auth/checkEmail'
        });
      } else {
        this.openDialog = true;
        this.errorMsg = 'Please type an e-mail';
      }
    },
    cancel: function cancel() {
      this.stp = 0;
      this.password = '';
      this.confirmPassword = '';
      this.email = '';
      this.errorMsg = '';
      this.$store.dispatch('resetState');
      this.$router.push('/');
    },
    resetPassword: function resetPassword() {
      var obj = '';
      if (this.password === '' || this.confirmPassword === '') {
        this.openDialog = true;
        this.errorMsg = 'Please type a password';
      } else if (this.password === this.confirmPassword) {
        obj = {
          url: 'auth/setpwd',
          password: this.password,
          email: this.email,
          recaptchaToken: this.captchaToken
        };
        this.$store.dispatch('setNewPassword', obj);
      } else {
        this.openDialog = true;
        this.errorMsg = 'Password does not match';
      }
    },
    toLoginPage: function toLoginPage() {
      this.stp = 0;
      this.password = '';
      this.confirmPassword = '';
      this.email = '';
      this.errorMsg = '';
      this.captchaToken = '';
      this.$store.dispatch('resetState');
      this.$router.push('/');
    },

    onSubmit: function onSubmit() {
      this.$refs.recaptcha.execute();
    },
    onVerify: function onVerify(response) {
      this.captchaToken = response;
    },
    onExpired: function onExpired() {
      console.log('Expired');
    }
  }
});

/***/ }),

/***/ "o/i4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddDisplay_vue__ = __webpack_require__("8AAR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46eff655_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddDisplay_vue__ = __webpack_require__("scfw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddDisplay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46eff655_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddDisplay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p7/k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderBar_vue__ = __webpack_require__("/TaY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23683b20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderBar_vue__ = __webpack_require__("Y+xe");
function injectStyle (ssrContext) {
  __webpack_require__("Za2f")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23683b20"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23683b20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pILX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Display__ = __webpack_require__("Dxk3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dat: {
      type: Array
    },
    mapsData: {
      type: Array
    },
    railId: {
      type: String
    },
    cr: {
      type: Object
    },
    showButton: {
      type: Boolean
    },
    issues: {
      type: Array
    },
    showDisplayCaseSelector: {
      type: Boolean
    }
  },
  components: {
    displayItem: __WEBPACK_IMPORTED_MODULE_1__Display__["a" /* default */]
  },
  data: function data() {
    return {
      selected: '',
      showResults: false,
      displayCaseItem: [],
      maps: [],
      listIssues: [],
      s: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    showDisplay: 'showDisplay'
  })),
  watch: {
    dat: function dat() {
      if (this.maps.length !== 0) {
        this.$store.dispatch('toggleDisplay', false);
      }
    },
    mapsData: function mapsData() {
      if (this.maps.length !== 0 && this.displayCaseItem.length !== 0) {
        this.displayResults();
      }
    }
  },
  methods: {
    displayResults: function displayResults() {
      var _this = this;

      if (this.displayCaseItem.length === 0) {
        this.displayCaseItem.push(this.selected);
        this.mapsData.forEach(function (element) {
          if (element.serialCode === _this.selected.code) {
            _this.maps.push(element);
          }
        });
        this.issues.forEach(function (i) {
          if (i.code === _this.selected.code) {
            _this.listIssues.push(i);
          }
        });
        this.$store.dispatch('toggleDisplay', true);
      } else {
        this.displayCaseItem = [];
        this.maps = [];
        this.listIssues = [];
        this.displayCaseItem.push(this.selected);
        this.mapsData.forEach(function (element) {
          if (element.serialCode === _this.selected.code) {
            _this.maps.push(element);
          }
        });
        this.issues.forEach(function (i) {
          if (i.code === _this.selected.code) {
            _this.listIssues.push(i);
          }
        });
        this.$store.dispatch('toggleDisplay', true);
      }
    },
    showString: function showString() {
      var container = document.getElementById('top');
      container.scrollTop = 0;
      container.pageYOffset = 0;
    },
    onScroll: function onScroll(e) {
      document.documentElement.scrollTop = 0;
    }
  }
});

/***/ }),

/***/ "qDFH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('v-card',{staticClass:"elevation-12"},[_c('v-toolbar',{attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Sign Up - Display Case Manager")])],1),_vm._v(" "),_c('v-card-text',[_c('v-form',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],attrs:{"prepend-icon":"mail","name":"email","label":"E-mail","error-messages":_vm.errors.collect('user.email'),"type":"text","data-vv-name":"user.email","required":""},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required:true, regex:/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/'),expression:"'required:true, regex:/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/'"}],attrs:{"id":"password","prepend-icon":"lock","name":"password","data-vv-name":"user.password","error-messages":_vm.errors.collect('user.password'),"required":"","label":"Password","type":_vm.show2 ? 'text' : 'password',"append-icon":_vm.show2 ? 'visibility_off': 'visibility'},on:{"click:append":function($event){_vm.show2 = !_vm.show2}},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|alpha'),expression:"'required|alpha'"}],attrs:{"prepend-icon":"person","id":"fname","name":"fname","label":"First Name","type":"text","data-vv-name":"user.firstName","error-messages":_vm.errors.collect('user.firstname'),"required":""},model:{value:(_vm.user.firstName),callback:function ($$v) {_vm.$set(_vm.user, "firstName", $$v)},expression:"user.firstName"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|alpha'),expression:"'required|alpha'"}],attrs:{"prepend-icon":"person","id":"lname","name":"lname","label":"Last Name","type":"text","data-vv-name":"user.lastName","error-messages":_vm.errors.collect('user.lastname'),"required":""},model:{value:(_vm.user.lastName),callback:function ($$v) {_vm.$set(_vm.user, "lastName", $$v)},expression:"user.lastName"}}),_vm._v(" "),_c('captcha',{ref:"recaptcha",attrs:{"sitekey":_vm.siteKey},on:{"verify":_vm.onVerify,"expired":_vm.onExpired}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"dark":""},nativeOn:{"click":function($event){return _vm.signup($event)}}},[_vm._v("Sign Up")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},nativeOn:{"click":function($event){return _vm.cancel($event)}}},[_vm._v("Cancel")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.openDialog),callback:function ($$v) {_vm.openDialog=$$v},expression:"openDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"error white--text"},[_c('v-icon',{staticClass:"white--text pr-3"},[_vm._v("warning")]),_c('span',[_vm._v("Sign up - Error")]),_vm._v(" "),_c('v-icon',{staticClass:"white--text pl-2"},[_vm._v("fa-frown-o")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v(_vm._s(_vm.errorMsg))])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.openDialog=false}}},[_vm._v("Close")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.grant),callback:function ($$v) {_vm.grant=$$v},expression:"grant"}},[_c('v-card',[_c('v-card-title',{staticClass:"success white--text"},[_c('v-icon',{staticClass:"white--text pr-3"},[_vm._v("check")]),_c('span',[_vm._v("User Created")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v(_vm._s(_vm.msg)+" "),_c('v-icon',{staticClass:"white--text pl-2"},[_vm._v("tag_faces")])],1)]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();return _vm.toLogin(_vm.grant=false)}}},[_vm._v("Ok")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qGEl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('div',[_c('h3',[_vm._v("Reset Password")]),_vm._v(" "),_c('p',[_vm._v("Follow the steps below to reset your password")])]),_vm._v(" "),_c('v-stepper',{attrs:{"vertical":""},model:{value:(_vm.stp),callback:function ($$v) {_vm.stp=$$v},expression:"stp"}},[_c('v-stepper-step',{attrs:{"complete":_vm.stp > 1,"step":"1"}},[_vm._v("\n              Let's check if your e-mail is in the Database\n              "),_c('small',[_vm._v("Please enter the email you used to sign up")])]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"1"}},[_c('form',[_c('v-text-field',{attrs:{"prepend-icon":"person","name":"login","label":"E-mail","type":"text"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},nativeOn:{"click":function($event){return _vm.verifyEmail($event)}}},[_vm._v("Verify Email")])],1)]),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.stp > 2,"step":"2"}},[_vm._v("Enter a new password")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('form',[_c('v-text-field',{attrs:{"prepend-icon":"lock","name":"password","label":"New Password","type":_vm.show1 ? 'text' : 'password',"hint":"At least 8 characters","append-icon":_vm.show1 ? 'visibility_off': 'visibility',"rules":[_vm.rules.required, _vm.rules.min]},on:{"click:append":function($event){_vm.show1 = !_vm.show1}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"lock","name":"password2","label":"Confirm Password","type":_vm.show2 ? 'text' : 'password',"append-icon":_vm.show2 ? 'visibility_off': 'visibility',"rules":[_vm.rules.required, _vm.rules.min]},on:{"click:append":function($event){_vm.show2 = !_vm.show2}},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}}),_vm._v(" "),_c('captcha',{ref:"recaptcha",attrs:{"sitekey":_vm.siteKey},on:{"verify":_vm.onVerify,"expired":_vm.onExpired}}),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},nativeOn:{"click":function($event){return _vm.resetPassword($event)}}},[_vm._v("Reset Password")])],1)]),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.stp > 3,"step":"3"}},[_vm._v("Login with your new Password")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('span',[_vm._v("Click the button to login page")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},nativeOn:{"click":function($event){return _vm.toLoginPage($event)}}},[_vm._v("Login")])],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},nativeOn:{"click":function($event){return _vm.cancel($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.openDialog),callback:function ($$v) {_vm.openDialog=$$v},expression:"openDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"error white--text"},[_c('v-icon',{staticClass:"white--text pr-3"},[_vm._v("warning")]),_c('span',[_vm._v("Something is wrong...")]),_vm._v(" "),_c('v-icon',{staticClass:"white--text pl-2"},[_vm._v("fa-frown-o")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v(_vm._s(_vm.errorMsg))])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.openDialog=false}}},[_vm._v("ok")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qpoU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddMap_vue__ = __webpack_require__("tawP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9ba1590_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddMap_vue__ = __webpack_require__("SHV0");
function injectStyle (ssrContext) {
  __webpack_require__("G2X2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9ba1590_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "scfw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","md8":"","lg7":""}},[_c('v-card',[_c('v-alert',{attrs:{"dismissible":"","type":"error"},model:{value:(_vm.alertInput),callback:function ($$v) {_vm.alertInput=$$v},expression:"alertInput"}},[_vm._v("\n                    'Upps something is wrong! Please correct the mistakes'\n                  ")]),_vm._v(" "),_c('v-toolbar',{attrs:{"color":_vm.cr.colorName}},[_c('v-toolbar-title',{staticClass:"body-3 white--text",attrs:{"color":_vm.cr.colorName}},[_vm._v(_vm._s(_vm.title))]),_vm._v("\n\t\t\t\t\t\t\t "),_c('v-icon',{staticClass:"pt-0",attrs:{"dark":""}},[_vm._v(_vm._s(_vm.icon))])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-form',{ref:"form"},[_c('h2',[_vm._v("Description")]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:75'),expression:"'required|max:75'"}],attrs:{"label":"Portal Name","hint":"Name of the station ie. San Pedro Station","persistent-hint":"","error-messages":_vm.errors.collect('portal_name'),"data-vv-name":"portal_name","required":""},model:{value:(_vm.portal_name),callback:function ($$v) {_vm.portal_name=$$v},expression:"portal_name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:50'),expression:"'required|max:50'"}],attrs:{"label":"Location Description","hint":"Ex: Portal South...  ","persistent-hint":"","error-messages":_vm.errors.collect('loc_descrp'),"data-vv-name":"loc_descrp","disable":"","required":""},model:{value:(_vm.loc_descrp),callback:function ($$v) {_vm.loc_descrp=$$v},expression:"loc_descrp"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:15|regex:^[A-Za-z]+\_[0-9A-Z]+\_[0-9A-Z]+'),expression:"'required|max:15|regex:^[A-Za-z]+\\_[0-9A-Z]+\\_[0-9A-Z]+'"}],attrs:{"label":"Display Case Code","hint":"Example B_GR_2e","persistent-hint":"","error-messages":_vm.errors.collect('code'),"data-vv-name":"code","required":"","readonly":_vm.readonly},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}})],1)],1),_vm._v(" "),_c('v-spacer',{staticClass:"blue--text lighten-2 mt-4 mb-2"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('h2',[_vm._v("Properties")]),_vm._v(" "),_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input-group--focused",attrs:{"items":_vm.displayType,"label":"Type","item-value":"text","hint":_vm.typeHint,"persistent-hint":"","error-messages":_vm.errors.collect('type'),"data-vv-name":"type","required":""},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:25'),expression:"'required|max:25'"}],attrs:{"label":"Size","hint":"Size of the diplay 47x47","persistent-hint":"","error-messages":_vm.errors.collect('size'),"data-vv-name":"size","required":""},model:{value:(_vm.size),callback:function ($$v) {_vm.size=$$v},expression:"size"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|between:33,35|decimal:6'),expression:"'required|between:33,35|decimal:6'"}],attrs:{"label":"Latitude","hint":"Latitude from 33.00 to 35.00","persistent-hint":"","error-messages":_vm.errors.collect('latitude'),"data-vv-name":"latitude"},model:{value:(_vm.latitude),callback:function ($$v) {_vm.latitude=$$v},expression:"latitude"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|between:-119,-117|decimal:7'),expression:"'required|between:-119,-117|decimal:7'"}],attrs:{"label":"Longitude","hint":"Longitude from -119.00 to -117.00","persistent-hint":"","error-messages":_vm.errors.collect('longitude'),"data-vv-name":"longitude"},model:{value:(_vm.longitude),callback:function ($$v) {_vm.longitude=$$v},expression:"longitude"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input-group--focused",attrs:{"items":_vm.sharedDisplay,"label":"Shared","item-value":"text","hint":_vm.sharedHint,"persistent-hint":"","error-messages":_vm.errors.collect('shared'),"data-vv-name":"shared","required":""},model:{value:(_vm.shared),callback:function ($$v) {_vm.shared=$$v},expression:"shared"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input-group--focused",attrs:{"items":_vm.displayStatus,"label":"Status","item-value":"text","hint":_vm.statusHint,"persistent-hint":"","error-messages":_vm.errors.collect('status'),"data-vv-name":"status","required":""},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-btn',{staticClass:"white--text",attrs:{"color":_vm.cr.colorName},on:{"click":function($event){return _vm.validate()}}},[_vm._v("Save "),_c('v-icon',{staticClass:"pl-1"},[_vm._v("check_circle")])],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":_vm.cr.colorName},on:{"click":function($event){return _vm.cancel()}}},[_vm._v("Cancel "),_c('v-icon',{staticClass:"pl-1"},[_vm._v("cancel")])],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sk2h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tawP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    edit: {
      type: Object
    },
    add: {
      type: Boolean
    },
    hide: {
      type: Boolean
    },
    search: {},
    bulk: {
      type: Boolean
    },
    addData: {
      type: Object
    },
    cr: {
      type: Object
    }
  },
  data: function data() {
    return {
      alert: true,
      errorMessage: '',
      notes: '',
      postby: '',
      alertInput: false,
      direction: '',
      formTitle: 'Add Map',
      iconTitle: 'add_circle',
      caseNum: '',
      menuDateCreated: false,
      jobNum: '',
      menu: false,
      title: '',
      date: null,
      selected: '',
      serial: '',
      status: ['Active', 'Expired', 'Revision', 'Pending'],
      selectHint: 'Status of the display',
      openCloseForms: {
        edit: false,
        add: false,
        search: false
      },
      dataToSave: '',
      bulkEdit: {
        caseNum: '',
        title: '',
        jobNum: '',
        date: '',
        serialCode: '',
        status: '',
        caseDirection: ''
      },
      prevSerialCode: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({ currentUser: 'currentUser' })),
  watch: {
    edit: function edit(ve) {
      this.formTitle = 'Edit insert';
      this.iconTitle = 'edit';
      this.title = ve.title;
      this.caseNum = ve.caseNum;
      this.jobNum = ve.jobNum;
      this.postby = ve.postby;
      this.notes = ve.notes;
      this.date = ve.date;
      this.selected = ve.status;
      this.selectHint = 'Please choose "' + ve.status + '" Its the current value unless you want to change it :)';
      this.serial = ve.serialCode;
      this.direction = ve.caseDirection;
      this.openCloseForms.edit = true;
      this.openCloseForms.add = false;
      this.openCloseForms.search = false;
      this.$validator.reset();
    },
    add: function add() {
      this.openCloseForms.edit = false;
      this.openCloseForms.add = true;
      this.openCloseForms.search = false;
      this.$validator.reset();
    },
    search: function search() {
      this.formTitle = 'Edit Insert';
      this.iconTitle = 'edit';
      this.openCloseForms.edit = false;
      this.openCloseForms.add = false;
      this.openCloseForms.search = true;
      this.$validator.reset();
      var obj = this.search;
      if (obj.length > 1) {
        this.bulkEdit = {
          caseNum: '',
          title: '',
          jobNum: '',
          date: '',
          status: '',
          caseDirection: '',
          notes: '',
          postby: ''
        };
        this.resetValues();
      } else {
        this.title = obj[0].title;
        this.caseNum = obj[0].caseNum;
        this.jobNum = obj[0].jobNum;
        this.date = obj[0].date;
        this.notes = obj[0].notes;
        this.postby = obj[0].postby;
        this.selectHint = 'Please choose "' + obj[0].status + '" Its the current value unless you want to change it :)';
        this.direction = obj[0].caseDirection;
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      if (this.openCloseForms.search) {
        this.save();
      } else {
        this.$validator.validateAll().then(function (results) {
          if (results) {
            _this.save();
          } else {
            _this.alertInput = true;
            _this.errorMessage = 'Something went Wrong!! Please check the fields and try again!';
            setTimeout(function () {
              _this.alertInput = false;
            }, 5000);
          }
        });
      }
    },
    save: function save() {
      var vm = this;
      if (vm.openCloseForms.edit) {
        // edit map
        vm.dataToSave = {
          obj: {
            caseNum: vm.caseNum,
            title: vm.title,
            jobNum: vm.jobNum,
            date: vm.date,
            serialCode: vm.addData.code,
            status: vm.selected,
            caseDirection: vm.direction,
            mapDisplayId: vm.addData.displayId.toString(),
            displayFk: vm.addData.displayId,
            notes: vm.notes,
            postby: vm.postby
          },
          userFk: vm.currentUser.id,
          map_id: vm.edit.id,
          did: vm.addData.id,
          rline: vm.cr.name,
          portal: vm.addData.portal_name
        };
        if (vm.selected === 'Pending') {
          vm.dataToSave.obj.install_date = null;
          vm.dataToSave.obj.qc_date = null;
          vm.dataToSave.obj.isInstall = 'No';
        }
        vm.$http.post('/mapsdata/map/editmap', vm.dataToSave).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit('closeForm', vm.openCloseForms);
          __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit('saveForm', true);
        });
      }
      if (vm.openCloseForms.add) {
        // add map
        vm.$validator.reset();
        vm.dataToSave = {
          obj: {
            caseNum: vm.caseNum,
            title: vm.title,
            jobNum: vm.jobNum,
            date: vm.date === '' || vm.date === undefined ? null : vm.date,
            serialCode: vm.addData.code,
            status: vm.selected,
            caseDirection: vm.direction,
            mapDisplayId: vm.addData.displayId.toString(),
            displayFk: vm.addData.displayId,
            isInstall: 'No',
            notes: vm.notes,
            postby: vm.postby === '' || vm.postby === undefined ? null : vm.postby // set to null just in case user does not picked a date
          },
          userFk: vm.currentUser.id,
          did: vm.addData.id,
          rline: vm.cr.name,
          portal: vm.addData.portal_name
        };
        vm.$http.post('/mapsdata/map/createmap', vm.dataToSave).then(function (response) {
          vm.$refs.form.reset();
          __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit('closeForm', vm.openCloseForms);
          __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit('saveForm', true);
        });
      }
      if (vm.openCloseForms.search) {
        if (vm.search.length !== 1) {
          var results = [];
          var obj = {
            code: '',
            editObj: ''
          };
          for (var i = 0; i < vm.search.length; i++) {
            vm.bulkEdit.caseNum = vm.caseNum === '' ? vm.search[i].caseNum : vm.caseNum;
            vm.bulkEdit.title = vm.title === '' ? vm.search[i].title : vm.title;
            vm.bulkEdit.jobNum = vm.jobNum === '' ? vm.search[i].jobNum : vm.jobNum;
            vm.bulkEdit.date = vm.date === '' || vm.date === null ? vm.search[i].date : vm.date;
            vm.bulkEdit.status = vm.selected === '' ? vm.search[i].status : vm.selected;
            vm.bulkEdit.caseDirection = vm.direction === '' ? vm.search[i].caseDirection : vm.direction;
            vm.bulkEdit.mapDisplayId = vm.search[i].displayFk;
            vm.bulkEdit.notes = vm.notes === '' ? vm.search[i].notes : vm.notes;
            vm.bulkEdit.postby = vm.postby === '' ? vm.search[i].postby : vm.postby;
            vm.bulkEdit.displayFk = vm.search[i].displayFk; // parseInt(vm.search[i].display_id)
            vm.bulkEdit.userFk = vm.currentUser.id;
            vm.bulkEdit.did = vm.search[i].display_id;
            vm.bulkEdit.rline = vm.search[i].rail.split('-')[1];
            vm.bulkEdit.map_id = vm.search[i].id;
            vm.bulkEdit.portal = vm.search[i].station_name;
            obj.code = vm.search[i].serialCode;
            obj.editObj = vm.bulkEdit;
            if (vm.selected === 'Pending') {
              obj.editObj.install_date = null;
              obj.editObj.qc_date = null;
              obj.editObj.isInstall = 'No';
            }
            results.push(obj);
            obj = {
              code: '',
              editObj: ''
            };
            vm.bulkEdit = {};
          }
          vm.$http.post('/mapsdata/map/bulkEdit', results).then(function (response) {
            vm.$store.dispatch('closeForm');
            __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit('saveSearchEdit', response.data.msg);
          });
        } else {
          vm.dataToSave = {
            obj: {
              caseNum: vm.caseNum === '' ? vm.search[0].caseNum : vm.caseNum,
              title: vm.title === '' ? vm.search[0].title : vm.title,
              jobNum: vm.jobNum === '' ? vm.search[0].jobNum : vm.jobNum,
              date: vm.date === null || vm.date === '' ? vm.search[0].date : vm.date,
              serialCode: vm.search[0].serialCode,
              notes: vm.notes === '' ? vm.search[0].notes : vm.notes,
              status: vm.selected === '' ? vm.search[0].status : vm.selected,
              caseDirection: vm.direction === '' ? vm.search[0].caseDirection : vm.direction,
              mapDisplayId: vm.search[0].displayFk,
              displayFk: vm.search[0].displayFk,
              postby: vm.postby === null ? vm.search[0].postby : vm.postby
            },
            userFk: vm.currentUser.id,
            did: vm.search[0].display_id,
            rline: vm.search[0].rail.split('-')[1],
            map_id: vm.search[0].id,
            portal: vm.search[0].station_name
          };
          if (vm.selected === 'Pending') {
            vm.dataToSave.obj.install_date = null;
            vm.dataToSave.obj.qc_date = null;
            vm.dataToSave.obj.isInstall = 'No';
          }
          vm.$http.post('/mapsdata/map/editmap', vm.dataToSave).then(function (response) {
            vm.$store.dispatch('closeForm');
            __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit('saveSearchEdit', response.data.msg);
          });
        } // end else
      }
    },
    resetValues: function resetValues() {
      this.caseNum = '';
      this.title = '';
      this.jobNum = '';
      this.date = null;
      this.serialCode = '';
      this.selected = '';
      this.caseDirection = '';
      this.notes = '';
      this.postby = '';
    },
    cancel: function cancel() {
      if (this.openCloseForms.edit) {
        this.$validator.reset();
        __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit('closeForm', this.openCloseForms, this.edit);
      }
      if (this.openCloseForms.add) {
        this.$validator.reset();
        this.$refs.form.reset();
        __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit('closeForm', this.openCloseForms);
      }
      if (this.openCloseForms.search) {
        this.$validator.reset();
        this.$store.dispatch('closeForm');
      }
    }
  }
});

/***/ }),

/***/ "vvGB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wi2W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Forms_AddDisplay__ = __webpack_require__("o/i4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    data: {
      type: Array
    },
    railId: {
      type: String
    },
    showBtn: {
      type: Boolean
    },
    cr: {
      type: Object
    }
  },
  components: {
    formAddDisplay: __WEBPACK_IMPORTED_MODULE_1__Forms_AddDisplay__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    binding: function binding() {
      var binding = {};
      if (this.$vuetify.breakpoint.xsOnly || this.$vuetify.breakpoint.smOnly || this.$vuetify.breakpoint.mdOnly) binding.column = true;
      return binding;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    showDisplay: 'showDisplay'
  })),
  data: function data() {
    return {
      selected: '',
      items: this.data,
      openFormAddDisplay: false,
      openDialog: false,
      info: {},
      copySel: '',
      rname: '',
      imageUrl: '',
      showAddDisplayBtn: false,
      graphics: '',
      errorMsg: 'Please select a station'
    };
  },
  created: function created() {
    var vm = this;
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$on('closeFormDisplayAdd', function (data) {
      vm.openFormAddDisplay = data;
    });
  },

  methods: {
    showData: function showData(selected) {
      var vm = this;
      if (vm.selected !== '') {
        vm.copySel = vm.selected;
        vm.$emit('selectedItem', vm.copySel);
        vm.toggleBtn();
        vm.selected = '';
      } else {
        vm.openDialog = true;
      }
    },
    toggleBtn: function toggleBtn() {
      this.$emit('toggleBtn', true);
    },
    infoToAdd: function infoToAdd(dat) {
      var vm = this;
      this.openFormAddDisplay = true;
      dat.forEach(function (d) {
        if (d.id === vm.copySel) {
          vm.info = d;
        }
      });
    }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar_vue__ = __webpack_require__("p7/k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MainContent_vue__ = __webpack_require__("h123");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      title: 'Display Case Manager',
      menuItems: ['Metro Blue Line', 'Metro Red Line', 'Metro Green Line', 'Metro Gold Line', 'Metro Purple Line', 'Metro Red Line'],
      drawer: null,
      show: false,
      right: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({ currentUser: 'currentUser' })),
  created: function created() {
    this.checkLogin();
  },
  updated: function updated() {
    this.checkLogin();
  },

  methods: {
    checkLogin: function checkLogin() {
      if (this.$route.path === '/signup') {
        this.$router.push('/signup');
      } else if (this.$route.path === '/resetpassword') {
        this.$router.push('/resetpassword');
      } else {
        if (!this.currentUser && this.$route.path !== '/') {
          this.$router.push('/?redirect=' + this.$route.path);
        }
      }
    }
  },
  components: {
    headerbar: __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar_vue__["a" /* default */],
    MainContent: __WEBPACK_IMPORTED_MODULE_2__components_MainContent_vue__["default"]
  }
});

/***/ }),

/***/ "xJtk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z+f4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mx-0 px-0",attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm5":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.data,"item-text":"name","item-value":"id","label":"Select a Station","color":_vm.cr.colorName},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text ml-0",attrs:{"slot":"activator","small":"","color":_vm.cr.colorName},nativeOn:{"click":function($event){return _vm.showData($event)}},slot:"activator"},[_vm._v("Show")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',[(_vm.showBtn)?[_c('v-btn',{staticClass:"ml-0",on:{"click":function($event){$event.stopPropagation();return _vm.infoToAdd(_vm.data)}}},[_vm._v("Add Display "),_c('v-icon',{staticClass:"pl-1",attrs:{"color":_vm.cr.colorName}},[_vm._v("add_circle")])],1)]:_vm._e()],2)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","transition":"dialog-bottom-transition","overlay":true},model:{value:(_vm.openFormAddDisplay),callback:function ($$v) {_vm.openFormAddDisplay=$$v},expression:"openFormAddDisplay"}},[_c('v-card',[_c('v-toolbar',{staticClass:"white--text",staticStyle:{"flex":"0 0 auto"},attrs:{"color":_vm.cr.colorName}},[_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.openFormAddDisplay = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Form")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('formAddDisplay',{attrs:{"openAddForm":_vm.openFormAddDisplay,"addInfo":_vm.info,"railId":_vm.railId,"cr":_vm.cr}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.openDialog),callback:function ($$v) {_vm.openDialog=$$v},expression:"openDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"error white--text"},[_c('v-icon',{staticClass:"white--text pr-3"},[_vm._v("warning")]),_c('span',[_vm._v("Error")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v(_vm._s(_vm.errorMsg))])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.openDialog=false}}},[_vm._v("Close")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zdgq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__ = __webpack_require__("YEz/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f120c53a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__ = __webpack_require__("qDFH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f120c53a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.92887251e35f54bc9dc8.js